export default {
  'activity.addPromotionSettings': 'Add Promotion Settings',
  'activity.editPromotionSettings': 'Edit Promotion Settings',
  'activity.appIcon': 'App Icon',
  'activity.back': 'Back',
  'activity.basicSettings': 'Basic Settings',
  'activity.batchModify': 'Batch Modify',
  'activity.batchModifyMaxAmount': 'Batch Modify Daily Maximum Rebate',
  'activity.batchModifyRebate': 'Batch Modify Rebate',
  'activity.batchModifyTicket': 'Batch Modify Spin Ticket',
  'activity.batchModifyTicketCount': 'Batch Modify Ticket Quantity',
  'activity.cannotDelete': 'Cannot delete data',
  'activity.cannotDeleteWithBoundTickets': 'Delete only when no tickets are bound',
  'activity.clickToUpload': 'Click to upload',
  'activity.copyPromotion': 'Copy Promotion',
  'activity.currency': 'Currency',
  'activity.dataLoadFailed': 'Data load failed',
  'activity.deselectAll': 'Deselect All',
  'activity.displaySort': 'Display Sort',
  'activity.editCopy': 'Edit Content',
  'activity.enterBatchMaxAmount': 'Please enter batch maximum rebate amount',
  'activity.enterBatchRebate': 'Please enter batch rebate percentage',
  'activity.enterBetAmount': 'Please enter bet amount (inclusive)',
  'activity.enterDisplaySort': 'Please enter display sort',
  'activity.rewardExpireDays': 'Reward Expire Days',
  'activity.enterRewardExpireDays': 'Please enter reward expire days (-1 means no expiration)',
  'activity.rewardExpireDaysTooltip': 'Enter days, -1 means no expiration',
  'activity.rewardExpireDaysCannotBeZero': 'Reward expire days cannot be 0',
  'activity.showFlowMultiple': 'Flow Multiple Display Switch',
  'activity.showFlowMultipleOn': 'On',
  'activity.showFlowMultipleOff': 'Off',
  'activity.days': 'Days',
  'activity.activityIntroduction': 'Activity Introduction',
  'activity.enterActivityIntroduction': 'Please enter activity introduction',
  'activity.activityIcon': 'Activity Icon',
  'activity.selectActivityIcon': 'Please upload activity icon',
  'activity.detailUrl': 'Detail URL',
  'activity.enterDetailUrl': 'Please enter detail URL',
  'activity.enterMaxRebateAmount': 'Please enter maximum rebate amount',
  'activity.enterPromotionContent': 'Please enter promotion content',
  'activity.enterPromotionName': 'Please enter promotion name',
  'activity.enterRebatePercent': 'Please enter rebate percentage',
  'activity.enterTurnoverMultiple': 'Please enter turnover multiple',
  'activity.errorParsingMultiTypeName': 'Error parsing multi-type name',
  'activity.formValidationFailed': 'Form validation failed',
  'activity.gamePlatform': 'Game Platform',
  'activity.h5Icon': 'H5 Icon',
  'activity.language': 'Language',
  'activity.loadingTemplate': 'Loading real-time promotion template...',
  'activity.manualSend.add': 'Add',
  'activity.manualSend.back': 'Back',
  'activity.manualSend.batchImport': 'Batch Import',
  'activity.manualSend.bonusAmount': 'Bonus Amount',
  'activity.manualSend.bonusPoints': 'Bonus Points',
  'activity.manualSend.cash': 'Cash',
  'activity.manualSend.point': 'Points',
  'activity.manualSend.ticket': 'Spin Ticket',
  'activity.manualSend.confirmIssue': 'Confirm Issue',
  'activity.manualSend.search': 'Search',
  'activity.manualSend.reset': 'Reset',
  'activity.manualSend.execute': 'Execute',
  'activity.manualSend.memberAccount': 'Member Account',
  'activity.manualSend.enterMemberAccount': 'Please enter member account',
  'activity.confirmEnable': 'Are you sure you want to enable this activity?',
  'activity.confirmDisable': 'Are you sure you want to disable this activity?',
  'activity.manualSend.currency': 'Currency',
  'activity.manualSend.dataLoadFailed': 'Data Load Failed',
  'activity.manualSend.downloadTemplate': 'Download Template',
  'activity.manualSend.enterBonusAmount': 'Please enter bonus amount',
  'activity.manualSend.enterBonusPoints': 'Please enter bonus points',
  'activity.manualSend.enterMemberName': 'Please enter member name',
  'activity.manualSend.enterTurnoverMultiple': 'Please enter turnover multiple',
  'activity.manualSend.failCount': 'Fail Count',
  'activity.manualSend.importCount': 'Import Count',
  'activity.manualSend.importDetails': 'Import Details',
  'activity.manualSend.importStatus': 'Import Status',
  'activity.manualSend.importTime': 'Import Time',
  'activity.manualSend.memberName': 'Member Name',
  'activity.manualSend.operationSuccess': 'Operation Success',
  'activity.manualSend.operationTime': 'Operation Time',
  'activity.manualSend.operator': 'Operator',
  'activity.manualSend.promotionName': 'Promotion Name',
  'activity.manualSend.rewardType': 'Reward Type',
  'activity.manualSend.selectCurrency': 'Please select currency',
  'activity.manualSend.selectImportStatus': 'Please select import status',
  'activity.manualSend.selectPromotionName': 'Please select promotion name',
  'activity.manualSend.selectRewardType': 'Please select reward type',
  'activity.manualSend.successAmount': 'Success Amount',
  'activity.manualSend.successCount': 'Success Count',
  'activity.manualSend.turnoverMultiple': 'Turnover Multiple',
  'activity.manualSend.uploadFile': 'Please upload CSV or Excel file',
  'activity.manualSend.uploadSuccess': 'Add Success',
  'activity.manualSend.usageInstructions': 'Usage Instructions',
  'activity.manualSend.instruction1': 'Please download the import template first, batch import member quantity below 100k',
  'activity.manualSend.instruction2': 'For exceeding amounts, please upload in batches, maximum once every 5 minutes',
  'activity.manualSend.instruction3': 'Upload document size should not exceed 20M',
  'activity.manualSend.view': 'View',
  'activity.manualSend.selectTicket': 'Please select spin ticket',
  'activity.manualSend.ticketName': 'Spin Ticket Name',
  'activity.manualSend.ticketNameLabel': 'Select Spin Ticket',
  'activity.manualSend.batchImportSuccess': 'Batch import successful',
  'activity.manualSend.templateFileName': 'Spin Ticket Import Template.csv',
  'activity.manualSend.csvColumnMemberName': 'Member Name',
  'activity.manualSend.csvColumnQuantity': 'Quantity',
  'activity.manualSend.csvExampleRow': 'Please delete this example row-{{memberName}},{{quantity}}',
  'activity.manualSend.fileFormat': 'File Format: CSV format',
  'activity.manualSend.fileSize': 'File Size: Not exceeding 20MB',
  'activity.manualSend.columnFields': 'Column Fields: Member Name,Quantity',
  'activity.manualSend.totalIssuedQuantity': 'Total Issued Quantity',
  'activity.modifySuccess': 'Modify successful',
  'activity.operationSuccess': 'Operation successful',
  'activity.pcIcon': 'PC Icon',
  'activity.promotionCategory': 'Promotion Category',
  'activity.promotionContent': 'Promotion Content',
  'activity.promotionEffectiveTime': 'Promotion Effective Time',
  'activity.promotionName': 'Promotion Name',
  'activity.promotionSettings': 'Promotion Settings',
  'activity.promotionShowTime': 'Promotion Show Time',
  'activity.promotionTemplate': 'Promotion Template',
  'activity.rebate.awardMax': 'Maximum Award',
  'activity.rebate.betAmount': 'Bet Amount (Inclusive)',
  'activity.rebate.betAmountMax': 'Bet Amount (Exclusive)',
  'activity.rebate.betAmountMaxError': 'Maximum bet amount (exclusive) must be greater than bet amount (inclusive)',
  'activity.rebate.cashAmount': 'Cash Amount',
  'activity.rebate.cashAwardMethod': 'Cash Award Method',
  'activity.rebate.dailyRecharge': 'Daily Recharge',
  'activity.rebate.desireMultiple': 'Desire Multiple',
  'activity.rebate.enterAwardMax': 'Please enter maximum award amount',
  'activity.rebate.enterBetAmount': 'Please enter bet amount (inclusive)',
  'activity.rebate.enterBetAmountMax': 'Please enter bet amount (exclusive)',
  'activity.rebate.enterCashAmount': 'Please enter cash amount',
  'activity.rebate.enterDailyRecharge': 'Please enter daily recharge amount',
  'activity.rebate.enterDesireMultiple': 'Please enter desire multiple',
  'activity.rebate.enterPointAmount': 'Please enter point amount',
  'activity.rebate.fixedAmount': 'Fixed Amount',
  'activity.rebate.gamePlatform': 'Game Platform',
  'activity.rebate.percentage': 'Percentage',
  'activity.rebate.percentMaxTwoDecimals': 'Ratio must be non-negative with at most 2 decimal places',
  'activity.rebate.truncateNotice': 'Rebate ratio supports up to 2 decimal places. Cash rebate amounts keep 2 decimal places with the excess truncated (no rounding); awards below 0.01 are discarded and not distributed. Point rebates are not affected.',
  'activity.rebate.pointAmount': 'Point Amount',
  'activity.rebate.pointAwardMethod': 'Point Award Method',
  'activity.rebate.rebateSettings': 'Rebate Settings',
  'activity.rebate.selectCashAwardMethod': 'Please select cash award method',
  'activity.rebate.selectPointAwardMethod': 'Please select point award method',
  'activity.save': 'Save',
  'activity.saving': 'Saving...',
  'activity.selectAll': 'Select All',
  'activity.selectAppIcon': 'Please select App icon',
  'activity.selectCurrency': 'Please select currency',
  'activity.selectCurrencyFirst': 'Please select currency first',
  'activity.selectH5Icon': 'Please select H5 icon',
  'activity.selectLanguage': 'Please select language',
  'activity.selectPcIcon': 'Please select PC icon',
  'activity.selectPromotionCategory': 'Please select promotion category',
  'activity.selectPromotionEffectiveTime': 'Please select promotion effective time',
  'activity.selectPromotionShowTime': 'Please select promotion show time',
  'activity.selectPromotionTemplate': 'Please select promotion template',
  'activity.selectStatus': 'Please select status',
  'activity.selectTicket': 'Please select spin ticket',
  'activity.enterTicketCount': 'Please enter quantity',
  'activity.setMultiLanguage': 'Set Multi-language',
  'activity.turnoverMultiple': 'Turnover Multiple',
  'activity.type.action': 'Action',
  'activity.type.add': 'Add',
  'activity.type.addSuccess': 'Add successful',
  'activity.type.categoryName': 'Category Name',
  'activity.type.confirmDelete': 'Are you sure to delete?',
  'activity.type.dataLoadFailed': 'Data load failed',
  'activity.type.delete': 'Delete',
  'activity.type.deleteSuccess': 'Delete successful',
  'activity.type.edit': 'Edit',
  'activity.type.enterCategoryName': 'Please enter category name',
  'activity.type.enterRemarks': 'Please enter remarks',
  'activity.type.enterSort': 'Please enter sort',
  'activity.type.formValidationFailed': 'Form validation failed',
  'activity.type.language': 'Language',
  'activity.type.modifySuccess': 'Modify successful',
  'activity.type.operationTime': 'Operation Time',
  'activity.type.operator': 'Operator',
  'activity.type.remarks': 'Remarks',
  'activity.type.selectLanguage': 'Please select language',
  'activity.type.setMultiLanguage': 'Set Multi-language',
  'activity.type.sort': 'Sort',
  'activity.vipLevel': 'VIP{{level}}',
  'activity.welfare.amount': 'Promotion Amount',
  'activity.welfare.cash': 'Cash',
  'activity.welfare.claimed': 'Claimed',
  'activity.welfare.claimMethod': 'Claim Method',
  'activity.welfare.createTime': 'Create Time',
  'activity.welfare.claimTime': 'Claim Time',
  'activity.welfare.currency': 'Currency',
  'activity.welfare.dataLoadFailed': 'Data load failed',
  'activity.welfare.enterMemberAccount': 'Please enter member account',
  'activity.welfare.expireTime': 'Reward Expire Time',
  'activity.welfare.pointExpireTime': 'Point Expire Time',
  'activity.welfare.memberAccount': 'Member Account',
  'activity.welfare.point': 'Points',
  'activity.welfare.points': 'Promotion Points',
  'activity.welfare.promotionName': 'Promotion Name',
  'activity.welfare.rewardName': 'Reward Name',
  'activity.welfare.selectCurrency': 'Please select currency',
  'activity.welfare.selectPromotionName': 'Please select promotion name',
  'activity.welfare.selectStatus': 'Please select status',
  'activity.welfare.selectSubActivityName': 'Please select sub activity name',
  'activity.welfare.vipLevel': 'VIP Level',
  'activity.welfare.selectVipLevel': 'Please select VIP level',
  'activity.welfare.status': 'Promotion Status',
  'activity.welfare.subActivityName': 'Sub Activity Name',
  'activity.welfare.systemIssue': 'System Issue',
  'activity.welfare.status.available': 'Available',
  'activity.welfare.status.received': 'Received',
  'activity.welfare.status.expired': 'Expired',
  'activity.welfare.turnoverMultiple': 'Turnover Multiple',
  'activity.welfare.export': 'Export',
  'activity.welfare.exportLoading': 'Exporting data...',
  'activity.welfare.exportSuccess': 'Export successful',
  'activity.welfare.exportFail': 'Export failed',
  'common.currency': 'Currency',
  'common.status': 'Status',
  'activity.selectPromotionName': 'Please select promotion name',
  'activity.uploadValidFile': 'Please upload and parse a valid CSV or Excel file',
  'export.serialNumber': 'Serial Number',
  'export.fileName': 'File Name',
  'export.createDate': 'Create Date',
  'export.status': 'Status',
  'export.operation': 'Operation',
  'export.status.success': 'Success',
  'export.status.processing': 'Processing',
  'export.status.failed': 'Download Failed',
  'export.button.download': 'Download',
  'export.button.delete': 'Delete',
  'export.button.refresh': 'Refresh',
  'export.button.clearAll': 'Clear All',
  'export.downloadList': 'Download List',
  'export.noData': 'No Data',
  'activity.register.cashAmount': 'Cash Reward Amount',
  'activity.register.cashAmountMustBeNonNegative': 'Cash reward amount cannot be negative',
  'activity.register.cashAmountTooltip': 'Cash reward amount received upon user registration, up to 2 decimal places',
  'activity.register.cashRequiresMultiple': 'Turnover multiple must be set when cash reward is greater than 0',
  'activity.register.desireMultiple': 'Turnover Multiple',
  'activity.register.desireMultipleTooltip': 'Turnover multiple requirement for cash rewards, must be integer',
  'activity.register.enterCashAmount': 'Please enter cash reward amount',
  'activity.register.enterDesireMultiple': 'Please enter turnover multiple',
  'activity.register.enterPointAmount': 'Please enter points reward amount',
  'activity.register.note': 'Notes',
  'activity.register.noteCashDecimal': 'Cash reward amount can have up to 2 decimal places',
  'activity.register.noteCashMultiple': 'Turnover multiple must be set when cash reward is greater than 0',
  'activity.register.noteMultipleInteger': 'Turnover multiple must be integer',
  'activity.register.noteOnePerUser': 'Each user can only claim once per activity',
  'activity.register.notePointInteger': 'Points reward amount must be integer',
  'activity.register.pointAmount': 'Points Reward Amount',
  'activity.register.pointAmountMustBeNonNegative': 'Points reward amount cannot be negative',
  'activity.register.pointAmountTooltip': 'Points reward amount received upon user registration, must be integer',
  'activity.register.promotionSettings': 'Registration Promotion Settings',
  'activity.register.ticketReward': 'Spin Ticket Reward',
  'activity.register.ticket': 'Spin Ticket',
  'activity.register.selectTicketTooltip': 'Select the type of spin ticket to grant',
  'activity.register.selectTicketPlaceholder': 'Please select spin ticket',
  'activity.register.ticketCount': 'Ticket Quantity',
  'activity.register.ticketCountRequired': 'Quantity must be entered after selecting ticket',
  'activity.register.ticketCountNonNegative': 'Quantity cannot be negative',
  'activity.register.ticketCountTooltip': 'Set the quantity of spin tickets to grant',
  'activity.register.enterTicketCount': 'Please enter quantity',
  'activity.register.addTicket': 'Add Ticket',
  'activity.register.spinTickets': 'Spin Ticket Settings',
  'activity.register.addSpinTicket': '+ Add Spin Ticket',
  'activity.register.distributeMode': 'Distribution Method',
  'activity.register.distributeModeDirect': 'Direct to User Account',
  'activity.register.distributeModeDirectDesc': 'Upon first login, cash is credited to the main account, points to the points account, and spin turns are granted automatically',
  'activity.register.distributeModeCoupon': 'To Promotion Center (Pending Claim)',
  'activity.register.distributeModeCouponDesc': 'Upon first login, rewards appear in the Promotion Center and are credited after manual claim by the user',
  'activity.register.distributeModeNote': 'Both methods take effect on the first login after registration, suitable for time-phased reward scenarios for imported users',
  'activity.register.defaultReward': 'Default Reward',
  'activity.register.defaultRewardDesc': 'Applied when no agent line rule is matched',
  'activity.register.spinCount': 'Spin Count',
  'activity.register.spinTicket': 'Spin Game',
  'activity.register.spinTicketPlaceholder': 'Default Spin',
  'activity.register.agentLineRules': 'Different Rewards by Agent Line',
  'activity.register.rule': 'Rule',
  'activity.register.agentLines': 'Applicable Agent Lines',
  'activity.register.addAgentLine': '+ Add Agent Line',
  'activity.register.addAgentLineRule': '+ Add Agent Line Rule',
  'activity.register.agentIdDuplicate': 'The same agent cannot appear in multiple rules',
  'activity.register.agentLinesRequired': 'Please select at least one agent line',
  'activity.register.onlyTempUser': 'Dispatch to Temp-Table Users Only',
  'activity.register.onlyTempUserDesc': 'When enabled, rewards are dispatched only to temporary-table registered users; users from other sources are skipped',

  // Daily First Recharge Template
  'activity.dailyFirstRecharge.title': 'Daily First Recharge Settings',
  'activity.dailyFirstRecharge.basicSettings': 'Basic Settings',
  'activity.dailyFirstRecharge.cashRewardSettings': 'Cash Reward Settings',
  'activity.dailyFirstRecharge.pointRewardSettings': 'Points Reward Settings',
  'activity.dailyFirstRecharge.rewardLimitSettings': 'Reward Limit Settings',
  'activity.dailyFirstRecharge.dailyMinRechargeAmount': 'Daily Minimum Deposit (Inclusive)',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmount': 'Daily Maximum Deposit (Inclusive)',
  'activity.dailyFirstRecharge.cashAwardMethod': 'Cash Award Method',
  'activity.dailyFirstRecharge.cashAmount': 'Cash Amount',
  'activity.dailyFirstRecharge.desireMultiple': 'Turnover Multiple',
  'activity.dailyFirstRecharge.pointAwardMethod': 'Points Award Method',
  'activity.dailyFirstRecharge.pointAmount': 'Points Amount',
  'activity.dailyFirstRecharge.awardMax': 'Maximum Award Limit',
  'activity.dailyFirstRecharge.enterDailyMinRechargeAmount': 'Please enter daily minimum deposit amount',
  'activity.dailyFirstRecharge.enterDailyMaxRechargeAmount': 'Please enter daily maximum deposit amount',
  'activity.dailyFirstRecharge.selectCashAwardMethod': 'Please select cash award method',
  'activity.dailyFirstRecharge.selectPointAwardMethod': 'Please select points award method',
  'activity.dailyFirstRecharge.enterCashAmount': 'Please enter cash amount',
  'activity.dailyFirstRecharge.enterDesireMultiple': 'Please enter turnover multiple',
  'activity.dailyFirstRecharge.enterPointAmount': 'Please enter points amount',
  'activity.dailyFirstRecharge.enterAwardMax': 'Please enter maximum award limit',
  'activity.dailyFirstRecharge.fixedAmount': 'Fixed Amount',
  'activity.dailyFirstRecharge.percentage': 'Percentage',
  'activity.dailyFirstRecharge.amountMustBeNonNegative': 'Amount cannot be negative',
  'activity.dailyFirstRecharge.amountMustBePositive': 'Amount must be greater than 0',
  'activity.dailyFirstRecharge.multipleMustBePositive': 'Turnover multiple must be greater than 0',
  'activity.dailyFirstRecharge.maxMustBeGreaterThanMin': 'Maximum deposit must be greater than minimum deposit',
  'activity.dailyFirstRecharge.dailyMinRechargeAmountTooltip': 'User\'s daily cumulative deposit must reach this amount to participate in the activity',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmountTooltip': 'Upper limit of user\'s daily cumulative deposit, amounts exceeding this limit do not participate in activity calculation',
  'activity.dailyFirstRecharge.cashAwardMethodTooltip': 'Choose cash reward calculation method: fixed amount or percentage based on deposit',
  'activity.dailyFirstRecharge.cashAmountTooltip': 'Fixed method: direct reward amount; Percentage method: reward percentage (e.g., 10 means 10%)',
  'activity.dailyFirstRecharge.desireMultipleTooltip': 'Turnover requirement multiple for obtaining cash rewards',
  'activity.dailyFirstRecharge.pointAwardMethodTooltip': 'Choose points reward calculation method: fixed amount or percentage based on deposit',
  'activity.dailyFirstRecharge.pointAmountTooltip': 'Fixed method: direct reward points amount; Percentage method: reward percentage (e.g., 5 means 5%)',
  'activity.dailyFirstRecharge.awardMaxTooltip': 'Maximum total reward amount limit that users can receive in a single activity',
  'activity.dailyFirstRecharge.note': 'Notes',
  'activity.dailyFirstRecharge.noteAmountRange': 'Daily minimum deposit must be less than daily maximum deposit',
  'activity.dailyFirstRecharge.noteAwardMethod': 'Award Method: Fixed = Direct amount/quantity, Percentage = Calculated by deposit percentage',
  'activity.dailyFirstRecharge.noteFlowMultiple': 'Flow multiple is used for cash reward withdrawal requirements',
  'activity.dailyFirstRecharge.noteAwardMax': 'Maximum award limit is the total cap for cash and point rewards',
  'activity.dailyFirstRecharge.dailyMinAmount': 'Daily Min Amount',
  'activity.dailyFirstRecharge.dailyMaxAmount': 'Daily Max Amount',
  'activity.dailyFirstRecharge.dailyMinAmountTooltip': 'Minimum limit for member daily deposit amount',
  'activity.dailyFirstRecharge.dailyMaxAmountTooltip': 'Maximum limit for member daily deposit amount',
  'activity.dailyFirstRecharge.dailyMaxAmountError': 'Daily max amount must be greater than min amount',
  'activity.dailyFirstRecharge.enterCashPercentage': 'Enter cash reward percentage',
  'activity.dailyFirstRecharge.enterPointPercentage': 'Enter point reward percentage',
  'activity.dailyFirstRecharge.percentageMaxError': 'Percentage cannot exceed 100%',
  'activity.dailyFirstRecharge.rechargePageDescription': 'Recharge Page Description',
  'activity.dailyFirstRecharge.descriptionZhCN': 'Simplified Chinese',
  'activity.dailyFirstRecharge.descriptionEnUS': 'English',
  'activity.dailyFirstRecharge.descriptionViVN': 'Vietnamese',
  'activity.dailyFirstRecharge.enterDescription': 'Please enter description',

  // Recharge Bonus Settings
  'activity.recharge.title': 'Recharge Bonus Settings',
  'activity.recharge.rechargeCount': 'Recharge Count for This Activity',
  'activity.recharge.minRechargeAmount': 'Minimum deposit (inclusive)',
  'activity.recharge.maxRechargeAmount': 'Maximum deposit (inclusive)',
  'activity.recharge.cashRewardSettings': "Cash",
  'activity.recharge.pointRewardSettings': 'Points',
  'activity.recharge.awardMax': 'Maximum Reward Limit',
  'activity.recharge.addCondition': 'Add Recharge Condition',
  'activity.recharge.confirmDelete': 'Confirm to delete this condition?',
  'activity.recharge.enterRechargeCount': 'Please enter recharge count',
  'activity.recharge.enterMinRechargeAmount': 'Please enter minimum single recharge amount',
  'activity.recharge.enterMaxRechargeAmount': 'Please enter maximum single recharge amount',
  'activity.recharge.selectCashAwardMethod': 'Please select cash reward method',
  'activity.recharge.selectPointAwardMethod': 'Please select points reward method',
  'activity.recharge.enterCashAmount': 'Please enter cash amount',
  'activity.recharge.enterDesireMultiple': 'Please enter turnover multiple',
  'activity.recharge.enterPointAmount': 'Please enter points amount',
  'activity.recharge.enterAwardMax': 'Please enter maximum reward limit',
  'activity.recharge.enterCashPercentage': 'Please enter cash reward percentage',
  'activity.recharge.enterPointPercentage': 'Please enter points reward percentage',
  'activity.recharge.fixedAmount': 'Fixed Amount',
  'activity.recharge.percentage': 'Percentage',
  'activity.recharge.amountMustBePositive': 'Amount must be greater than 0',
  'activity.recharge.rechargeCountMustBePositiveInteger': 'Recharge count must be a positive integer',
  'activity.recharge.maxAmountError': 'Maximum recharge amount must be greater than minimum amount',
  'activity.recharge.percentageMaxError': 'Percentage cannot exceed 100%',
  'activity.recharge.truncateNotice': 'Bonus ratio supports up to 2 decimal places. Percentage-based cash rewards keep 2 decimal places with the excess truncated (no rounding); rewards below 0.01 are discarded and not distributed. Point rewards are not affected.',
  'activity.recharge.cashAwardMethodTooltip': 'Choose cash reward calculation method: fixed amount or percentage of recharge',
  'activity.recharge.pointAwardMethodTooltip': 'Choose points reward calculation method: fixed quantity or percentage of recharge',
  'activity.recharge.awardMaxTooltip': 'Maximum reward amount limit users can receive in a single activity',
  'activity.recharge.rechargeCountMustBeUnique': 'Recharge count cannot be duplicated',
  'activity.recharge.rechargeCountMustBeConsecutive': 'Recharge count must be consecutive',
  'activity.recharge.cannotBothBeZero': 'Cash reward and points reward cannot both be 0',
  'activity.recharge.stage': 'Stage',
  'activity.recharge.copyStage': 'Copy Stage',
  'activity.recharge.deleteStage': 'Delete Stage',
  'activity.recharge.enterRechargeCountPlaceholder': 'Please enter N, e.g., 1st, 2nd',
  'activity.recharge.awardDistribution': 'Award Distribution',
  'activity.recharge.cashAward': 'Cash Reward',
  'activity.recharge.selectAwardMethod': 'Please select reward method',
  'activity.recharge.enterPercentage': 'Please enter percentage',
  'activity.recharge.enterFixedAmount': 'Please enter fixed amount',
  'activity.recharge.maxCashAmount': 'Please enter max cash amount (-1 for unlimited)',
  'activity.recharge.maxAmountValidation': 'Please enter -1 or a value greater than or equal to 0',
  'activity.recharge.desireMultiple': 'Please enter turnover multiple (empty or 0 for no limit)',
  'activity.recharge.pointAward': 'Points Reward',
  'activity.recharge.enterFixedPoints': 'Please enter fixed points',
  'activity.recharge.maxPointAmount': 'Please enter max points amount (-1 for unlimited)',
  'activity.recharge.lotteryTicket': 'Lottery Ticket',
  'activity.recharge.selectLotteryActivity': 'Please select lottery activity',
  'activity.recharge.ticketCount': 'Please enter quantity (default 1)',
  'activity.recharge.enterTicketCount': 'Please enter quantity',
  'activity.recharge.ticketCountNonNegative': 'Quantity cannot be negative',
  'activity.recharge.addStage': '+ Add Stage',
  // CB7REQ-331 阶段内金额阶梯
  'activity.recharge.tier': 'Tier',
  'activity.recharge.addTier': '+ Add Tier',
  'activity.recharge.deleteTier': 'Delete Tier',
  'activity.recharge.tierLast': 'Last tier · no upper limit',
  'activity.recharge.tierRangeNoUpper': '≥ {min} (inclusive), no upper limit',
  'activity.recharge.tierRange': '{min} (inclusive) – {max} (exclusive)',
  'activity.recharge.tierRangePending': 'Range pending correction',
  'activity.recharge.tierMinMustIncrease': 'Tier minimum must be strictly greater than the previous tier',
  'activity.recharge.tierListTitle': 'Amount tiers (matched by single deposit amount, mutually exclusive)',
  'activity.recharge.tierListHint': 'Deposits below the first tier minimum get no reward · Only enter "Minimum deposit (inclusive)" per tier; the upper limit is automatically the next tier minimum (exclusive), the last tier has no upper limit · Tier minimums must be strictly increasing; the backend re-validates on save',
  'activity.recharge.tierUpperAuto': 'Upper limit = next tier minimum (exclusive)',
  'activity.recharge.capOnlyLastTier': 'Cap fields appear only on the last tier (it has no upper bound, so percentage rewards need a cap); -1 means unlimited.',

  // Login Recharge Template
  'activity.loginRecharge.promotionSettings': 'Login Recharge Draw Settings',
  'activity.loginRecharge.awardName': 'Award Name',
  'activity.loginRecharge.pointAmount': 'Point Amount',
  'activity.loginRecharge.winners': 'Number of Winners',
  'activity.loginRecharge.type': 'Award Type',
  'activity.loginRecharge.deposit': 'Deposit',
  'activity.loginRecharge.login': 'Login',
  'activity.loginRecharge.addCondition': 'Add Condition',
  'activity.loginRecharge.atLeastOneCondition': 'At least one condition is required',
  'activity.loginRecharge.awardNameRequired': 'Award name is required',
  'activity.loginRecharge.pointAmountRequired': 'Point amount is required',
  'activity.loginRecharge.winnersRequired': 'Number of winners is required',
  'activity.loginRecharge.enterAwardName': 'Please enter award name',
  'activity.loginRecharge.awardNameMaxLength': 'Award name cannot exceed 100 characters',
  'activity.loginRecharge.enterPointAmount': 'Please enter point amount',
  'activity.loginRecharge.pointAmountMustBePositive': 'Point amount must be greater than 0',
  'activity.loginRecharge.enterWinners': 'Please enter number of winners',
  'activity.loginRecharge.winnersMustBePositive': 'Number of winners must be greater than 0',
  'activity.loginRecharge.selectType': 'Please select award type',
  'activity.loginRecharge.memberAccount': 'Member Account',
  'activity.loginRecharge.memberAccountPlaceholder': 'Please enter member account',

  // Activity Operate Management
  'activity.operate.loginRecharge': 'Login Recharge Draw',
  'activity.loginRecharge.triggerAmount': 'Trigger Amount',
  'activity.loginRecharge.drawDate': 'Draw Date',
  'activity.loginRecharge.activityName': 'Activity Name',
  'activity.loginRecharge.status': 'Status',
  'activity.loginRecharge.numberPlate': 'Number Plate',
  'activity.loginRecharge.awardStatus': 'Award Status',
  'activity.loginRecharge.createTime': 'Create Time',
  'activity.loginRecharge.pendingDraw': 'Pending Draw',
  'activity.loginRecharge.drawn': 'Drawn',
  'activity.loginRecharge.notWin': 'Not Win',
  'activity.loginRecharge.pendingAward': 'Pending Award',
  'activity.loginRecharge.received': 'Received',
  'activity.loginRecharge.awardStatusPlaceholder': 'Please select award status',
  'activity.loginRecharge.awardAmount': 'Award Amount',
  'activity.loginRecharge.operator': 'Operator',
  'activity.loginRecharge.operateTime': 'Operate Time',
  'activity.loginRecharge.updateShareLink': 'Update Share Link',
  'activity.loginRecharge.dataPkCode': 'System Serial Number',
  'activity.loginRecharge.shareLink': 'Share Link',
  'activity.loginRecharge.dataPkCodeRequired': 'System serial number cannot be empty',
  'activity.loginRecharge.shareLinkRequired': 'Share link cannot be empty',
  'activity.loginRecharge.shareLinkPlaceholder': 'Please enter share link',
  'activity.loginRecharge.socialMediaLink': 'Social Media Link',
  'activity.loginRecharge.invalidLink': 'Invalid link format',
  'activity.loginRecharge.sendAward': 'Send Award',
  'activity.loginRecharge.awardSentSuccess': 'Award sent successfully',
  'activity.loginRecharge.awardSentFail': 'Failed to send award',
  'activity.loginRecharge.awardSending': 'Award sending, please wait...',
  'activity.loginRecharge.batchSend': 'Batch Send',
  'activity.loginRecharge.batchSendConfirm': 'Confirm Batch Send',
  'activity.loginRecharge.batchSendConfirmMessage': 'Are you sure you want to batch send {{count}} selected records?\n\nNote: Batch sending will be processed asynchronously in the background. Please refresh the page later to view results.',
  'activity.loginRecharge.batchSendConfirmContent': 'Are you sure you want to batch send {{count}} selected records?',
  'activity.loginRecharge.batchSendAsyncNotice': 'Note: Batch sending will be processed asynchronously in the background. Please refresh the page later to view results. Do not send repeatedly.',
  'activity.loginRecharge.confirmSend': 'Confirm Send',
  'activity.loginRecharge.batchSendTaskSubmitted': 'Batch send task submitted, processing in background',
  'activity.loginRecharge.batchSendSuccess': 'Batch send task submitted successfully',
  'activity.loginRecharge.batchSendFail': 'Failed to submit batch send task',
  'activity.loginRecharge.batchSending': 'Submitting batch send task...',
  'activity.loginRecharge.selectRecordsToSend': 'Please select records to send',
  'activity.loginRecharge.selectRecordsFirst': 'Please select records to send first',
  'activity.loginRecharge.eligibleRecords': 'Eligible Records',
  'activity.loginRecharge.selectAllEligible': 'Select All Eligible',

  // Redemption Record Management
  'activity.redemptionRecord.useTime': 'Redemption Code Use Time',
  'activity.redemptionRecord.actNameOrId': 'Activity Name/ID',
  'activity.redemptionRecord.actNameOrIdPlaceholder': 'Please enter activity name or ID',
  'activity.redemptionRecord.redemptionCode': 'Redemption Code',
  'activity.redemptionRecord.redemptionCodePlaceholder': 'Please enter redemption code',
  'activity.redemptionRecord.memberAccount': 'Member Account',
  'activity.redemptionRecord.memberAccountPlaceholder': 'Please enter member account',
  'activity.redemptionRecord.promotionName': 'Promotion Name',
  'activity.redemptionRecord.usageMode': 'Usage Mode',
  'activity.redemptionRecord.awardContent': 'Award Content',
  'activity.redemptionRecord.distributionMethod': 'Distribution Method',
  'activity.redemptionRecord.redemptionTime': 'Redemption Time',

  // Redemption Code Management
  'activity.redemptionCode.list': 'Redemption Code List',
  'activity.redemptionCode.usageRecord': 'Redemption Code Usage Record',
  'activity.redemptionCode.promotionName': 'Promotion Name',
  'activity.redemptionCode.promotionId': 'Promotion ID',
  'activity.redemptionCode.awardAmount': 'Redemption Award',
  'activity.redemptionCode.status': 'Status',
  'activity.redemptionCode.enabled': 'Enabled',
  'activity.redemptionCode.disabled': 'Disabled',
  'activity.redemptionCode.codeQuantity': 'Code Quantity',
  'activity.redemptionCode.unlimited': 'Unlimited',
  'activity.redemptionCode.times': 'times',
  'activity.redemptionCode.usageMode': 'Usage Mode',
  'activity.redemptionCode.reusable': 'Reusable',
  'activity.redemptionCode.singleUse': 'Single Use',
  'activity.redemptionCode.unknown': 'Unknown',
  'activity.redemptionCode.distributionMethod': 'Distribution Method',
  'activity.redemptionCode.manualDistribution': 'Manual Distribution',
  'activity.redemptionCode.autoDistribution': 'Auto Distribution',
  'activity.redemptionCode.usedCount': 'Used Count',
  'activity.redemptionCode.operator': 'Operator',
  'activity.redemptionCode.availableTime': 'Available Time',
  'activity.redemptionCode.operation': 'Operation',
  'activity.redemptionCode.quantity': 'Quantity',
  // Redemption Code Forms and Modals
  'activity.redemptionCode.createSuccess': 'Created successfully',
  'activity.redemptionCode.createFailed': 'Creation failed',
  'activity.redemptionCode.disableSuccess': 'Disabled successfully',
  'activity.redemptionCode.enableSuccess': 'Enabled successfully',
  'activity.redemptionCode.confirmDisable': 'Confirm Disable',
  'activity.redemptionCode.confirmEnable': 'Confirm Enable',
  'activity.redemptionCode.couponSettings': 'Coupon Settings',
  'activity.redemptionCode.promotionNameRequired': 'Please enter promotion name',
  'activity.redemptionCode.promotionNamePlaceholder': 'Please enter promotion name',
  'activity.redemptionCode.distributionMethodRequired': 'Please select distribution method',
  'activity.redemptionCode.distributionMethodPlaceholder': 'Please select distribution method',
  'activity.redemptionCode.usageModeRequired': 'Please select usage mode',
  'activity.redemptionCode.usageModePlaceholder': 'Please select usage mode',
  'activity.redemptionCode.availableTimeRequired': 'Please select available time',
  'activity.redemptionCode.perUserLimitRequired': 'Please enter per user limit',
  'activity.redemptionCode.perUserLimitPattern': 'Please enter positive integer',
  'activity.redemptionCode.perUserLimitPlaceholder': '1 (fixed)',
  'activity.redemptionCode.totalUsagePattern': 'Please enter -1 (unlimited) or positive integer',
  'activity.redemptionCode.totalUsagePlaceholder': '-1 (unlimited) or positive integer',
  'activity.redemptionCode.prefixRequired': 'Please enter single use prefix',
  'activity.redemptionCode.prefixMaxLength': 'Prefix maximum 4 characters',
  'activity.redemptionCode.prefixPattern': 'Only letters and numbers allowed',
  'activity.redemptionCode.prefixPlaceholder': 'e.g.: PROM',
  'activity.redemptionCode.awardTypeRequired': 'Please select award type',
  'activity.redemptionCode.awardTypePlaceholder': 'Please select award type',
  'activity.redemptionCode.pointAmountRequired': 'Please enter point amount',
  'activity.redemptionCode.pointAmountPattern': 'Please enter positive integer',
  'activity.redemptionCode.pointAmountPlaceholder': 'Point amount (positive integer)',
  'activity.redemptionCode.cashAmountRequired': 'Please enter cash amount',
  'activity.redemptionCode.cashAmountPattern': 'Please enter valid amount',
  'activity.redemptionCode.cashAmountPlaceholder': 'Cash amount',
  'activity.redemptionCode.currencyRequired': 'Please select currency',
  'activity.redemptionCode.currencyPlaceholder': 'Please select currency',
  'activity.redemptionCode.turnoverMultipleRequired': 'Please enter turnover multiple',
  'activity.redemptionCode.turnoverMultiplePlaceholder': 'Turnover multiple',
  // Redemption Code Operations and Modals
  'activity.redemptionCode.addCodes': 'Add Codes',
  'activity.redemptionCode.addUsageCount': 'Add Usage Count',
  'activity.redemptionCode.showUniqueCode': 'Redemption Code Info',
  'activity.redemptionCode.exportCodes': 'Export Codes',
  'activity.redemptionCode.copySuccess': 'Redemption code copied to clipboard',
  'activity.redemptionCode.copyFailed': 'Copy failed',
  'activity.redemptionCode.copyCode': 'Copy Redemption Code',
  'activity.redemptionCode.copyInstructions': 'Click "Copy Redemption Code" button to copy the code to clipboard',
  'activity.redemptionCode.batchNumber': 'Batch Number',
  'activity.redemptionCode.batchQuantity': 'Quantity',
  'activity.redemptionCode.generationStatus': 'Generation Status',
  'activity.redemptionCode.generating': 'Generating',
  'activity.redemptionCode.completed': 'Completed',
  'activity.redemptionCode.failed': 'Failed',
  'activity.redemptionCode.batchOperator': 'Operator',
  'activity.redemptionCode.batchCreateTime': 'Create Time',
  'activity.redemptionCode.batchOperation': 'Operation',
  'activity.redemptionCode.getBatchListFailed': 'Failed to get batch list',
  'activity.redemptionCode.exportFailed': 'Export failed',
  'activity.redemptionCode.availableDate': 'Available Date',
  'activity.redemptionCode.activityName': 'Activity Name',
  'activity.redemptionCode.activityNamePlaceholder': 'Please enter activity name',
  'activity.redemptionCode.creator': 'Creator',
  'activity.redemptionCode.creatorPlaceholder': 'Please enter creator',
  'activity.redemptionCode.statusPlaceholder': 'Please select status',
  // Additional missing translations
  'activity.redemptionCode.points': 'Points',
  'activity.redemptionCode.cash': 'Cash',
  'activity.redemptionCode.unlimitedTimes': 'Unlimited',
  'activity.redemptionCode.timesUnit': 'times',
  'activity.redemptionCode.quantityUnit': 'Quantity',
  'activity.redemptionCode.dataLoadFailed': 'Data load failed',
  'activity.redemptionCode.queryParams': 'Query parameters',
  'activity.redemptionCode.createRedemptionCodeFailed': 'Failed to create redemption code',
  'activity.redemptionCode.startTime': 'Start Time',
  'activity.redemptionCode.endTime': 'End Time',
  'activity.redemptionCode.totalUsageLabel': 'Total Usage Count (enter -1 for unlimited)',
  'activity.redemptionCode.prefixLabel': 'Prefix (max 4 characters, system generates 5)',
  'activity.redemptionCode.addCodesSuccess': 'Codes generated successfully',
  'activity.redemptionCode.addCodesFailed': 'Code generation failed',
  'activity.redemptionCode.addUsageCountSuccess': 'Usage count increased successfully',
  'activity.redemptionCode.addUsageCountFailed': 'Failed to increase usage count',
  'activity.redemptionCode.addCodesTitle': 'Add Codes',
  'activity.redemptionCode.addUsageCountTitle': 'Add Usage Count',
  'activity.redemptionCode.redemptionCodeName': 'Redemption Code Name',
  'activity.redemptionCode.currentTotalUsage': 'Current Total Usage',
  'activity.redemptionCode.unlimitedUsage': 'Unlimited',
  'activity.redemptionCode.addUsageCountRequired': 'Please enter usage count to add',
  'activity.redemptionCode.addUsageCountRange': 'Usage count must be between 1-100000',
  'activity.redemptionCode.addUsageCountPlaceholder': 'Please enter usage count to add',
  'activity.redemptionCode.singleUsePrefix': 'Single Use Prefix',
  'activity.redemptionCode.addCodesQuantityRequired': 'Please enter number of codes to add',
  'activity.redemptionCode.addCodesQuantityRange': 'Code quantity must be between 1-100000',
  'activity.redemptionCode.addCodesQuantityPlaceholder': 'Please enter number of codes to add',
  'activity.redemptionCode.showUniqueCodeTitle': 'Redemption Code Info',
  'activity.redemptionCode.exportCodesTitle': 'Export Codes',
  // Common translations
  'common.operation': 'Operation',
  'common.delete': 'Delete',
  'common.save': 'Save',
  'common.action': 'Action',
  'common.saveSuccess': 'Saved successfully',
  'common.saveFailed': 'Save failed',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.settings': 'Settings',
  'common.view': 'View',
  'common.all': 'All',
  // Additional missing translations for forms
  'activity.redemptionCode.codeUnit': 'pcs',
  'activity.redemptionCode.perUserUnit': 'times',
  'activity.redemptionCode.export': 'Export',
  // Button translations
  'common.search': 'Search',
  'common.reset': 'Reset',
  'common.add': 'Add',
  'common.disable': 'Disable',
  'common.enable': 'Enable',
  // Confirmation dialog messages
  'activity.redemptionCode.confirmDisableMessage': 'Are you sure you want to disable redemption code "{{actName}}"?',
  'activity.redemptionCode.confirmEnableMessage': 'Are you sure you want to enable redemption code "{{actName}}"?',
  // Show unique code modal
  'activity.redemptionCode.activityNameLabel': 'Activity Name:',
  'activity.redemptionCode.redemptionCodeLabel': 'Redemption Code:',
  'activity.redemptionCode.close': 'Close',
  // Add codes modal
  'activity.redemptionCode.uniqueCode': 'Unique Code',
  'activity.redemptionCode.addUsageCountLabel': 'Add Usage Count',
  'activity.redemptionCode.addCodesQuantityLabel': 'New Code Quantity',
  'activity.redemptionCode.cancel': 'Cancel',
  'activity.redemptionCode.confirm': 'Confirm',
  'activity.redemptionCode.reusableModeDescription': '• Reusable mode: Increase total usage count of redemption code',
  'activity.redemptionCode.systemUpdateDescription': '• System will update total usage limit of redemption code',
  'activity.redemptionCode.maxUsageDescription': '• Maximum support up to 100,000 uses',
  // Add redemption code modal
  'activity.redemptionCode.availableTimePlaceholder': ['Start Time', 'End Time'],
  'activity.redemptionCode.uniqueCodeRequired': 'Please enter unique code',
  'activity.redemptionCode.uniqueCodeEmpty': 'Code cannot be empty',
  'activity.redemptionCode.uniqueCodePlaceholder': 'e.g: PROMO2025',
  'activity.redemptionCode.perUserLimit': 'Per User Limit',
  'activity.redemptionCode.totalUsageLimit': 'Total Usage Limit (enter -1 for unlimited)',
  'activity.redemptionCode.totalUsageRequired': 'Please enter total usage limit',
  'activity.redemptionCode.singleUsePrefixLabel': 'Prefix (max 4 chars, system generates 5 chars)',
  'activity.redemptionCode.singleUsePrefixRequired': 'Please enter single use prefix',
  'activity.redemptionCode.singleUsePrefixMaxLength': 'Prefix max 4 characters',
  'activity.redemptionCode.singleUsePrefixPattern': 'Only letters and numbers allowed',
  'activity.redemptionCode.singleUsePrefixPlaceholder': 'e.g: PROM',
  'activity.redemptionCode.awardType': 'Award Type',
  'activity.redemptionCode.pointAmount': 'Point Amount',
  'activity.redemptionCode.cashAmount': 'Cash Amount',
  'activity.redemptionCode.currency': 'Currency',
  'activity.redemptionCode.turnoverMultiple': 'Turnover Multiple',
  'activity.redemptionCode.singleUseDescription': 'To ensure codes are short enough, system generates only 5 chars, single use tasks',
  'activity.redemptionCode.maxCodesDescription': 'Maximum 100,000 codes',
  // Reward mode (奖励模式)
  'activity.redemptionCode.rewardMode': 'Reward Mode',
  'activity.redemptionCode.rewardModeRequired': 'Please select reward mode',
  'activity.redemptionCode.rewardModePlaceholder': 'Please select reward mode',
  'activity.redemptionCode.fixedMode': 'Fixed',
  'activity.redemptionCode.rangeMode': 'Range',
  'activity.redemptionCode.randomReward': 'Random Reward',
  'activity.redemptionCode.randomPoints': 'Random Points',
  'activity.redemptionCode.randomCash': 'Random Cash',
  // Range settings (区间设置)
  'activity.redemptionCode.atLeastOneRange': 'Please add at least one range',
  'activity.redemptionCode.minAmount': 'Min Amount',
  'activity.redemptionCode.minAmountRequired': 'Please enter min amount',
  'activity.redemptionCode.minAmountMustBeGreaterThanZero': 'Min amount must be greater than 0',
  'activity.redemptionCode.maxAmount': 'Max Amount',
  'activity.redemptionCode.maxAmountRequired': 'Please enter max amount',
  'activity.redemptionCode.probability': 'Probability (%)',
  'activity.redemptionCode.probabilityRequired': 'Please enter probability',
  'activity.redemptionCode.probabilityMax100': 'Probability cannot exceed 100%',
  'activity.redemptionCode.positiveIntegerRequired': 'Please enter a positive integer',
  'activity.redemptionCode.validNumber': 'Please enter a valid number',
  'activity.redemptionCode.validNumberMax2Decimal': 'Please enter a valid number (max 2 decimal places)',
  'activity.redemptionCode.addRange': 'Add',
  'activity.redemptionCode.probabilitySumNote': 'Total probability of all ranges must be 100%',
  'activity.redemptionCode.probabilityMustBe100': 'Total probability of range settings must be 100%',
  'activity.redemptionCode.totalRecords': 'Total {{total}} records',

  // Lucky Spin Template
  'activity.luckySpin.pcIcon': 'PC Icon',
  'activity.luckySpin.selectPcIcon': 'Please select PC icon',
  'activity.luckySpin.h5Icon': 'H5 Icon',
  'activity.luckySpin.selectH5Icon': 'Please select H5 icon',
  'activity.luckySpin.appIcon': 'App Icon',
  'activity.luckySpin.selectAppIcon': 'Please select App icon',

  'activity.confirmDelete': 'Are you sure you want to delete the activity?',

  // Custom Template
  'activity.custom.taskType': 'Task Type',
  'activity.custom.selectTaskType': 'Please select task type',
  'activity.custom.once': 'Once',
  'activity.custom.repeat': 'Repeat',
  'activity.custom.taskCycle': 'Task Cycle',
  'activity.custom.selectTaskCycle': 'Please select task cycle',
  'activity.custom.daily': 'Daily',
  'activity.custom.weekly': 'Weekly',
  'activity.custom.permanent': 'Permanent',
  'activity.custom.cashRewardDisplay': 'Cash Reward Display',
  'activity.custom.enterCashRewardDisplay': 'Please enter cash reward display',
  'activity.custom.pointRewardDisplay': 'Point Reward Display',
  'activity.custom.enterPointRewardDisplay': 'Please enter point reward display',
  'activity.custom.ticketRewardDisplay': 'Ticket Reward Display',
  'activity.custom.enterTicketRewardDisplay': 'Please enter ticket reward display',
  'activity.custom.unlockButtonName': 'Unlock Status Button Name',
  'activity.custom.enterUnlockButtonName': 'Please enter unlock status button name',
  'activity.custom.buttonJumpLink': 'Button Jump Link',
  'activity.custom.enterButtonJumpLink': 'Please enter button jump link',
  'activity.custom.rewardDisplay': 'Reward Display Settings',
  'activity.custom.vipLevelMode': 'VIP Level Selection Mode',
  'activity.custom.singleSelect': 'Single Select',
  'activity.custom.multipleSelect': 'Multiple Select',
  'activity.custom.vipLevel': 'VIP Level',
  'activity.custom.vipLevels': 'VIP Levels',
  'activity.custom.selectVipLevel': 'Please select VIP level',
  'activity.custom.selectVipLevels': 'Please select VIP levels',

  // Every Recharge Template
  'activity.everyRecharge.configTitle': 'Every Recharge Bonus Configuration',
  'activity.everyRecharge.minRechargeAmount': 'Min Recharge ≥',
  'activity.everyRecharge.maxRechargeAmount': 'Max Recharge ≤',
  'activity.everyRecharge.awardType': 'Reward Type',
  'activity.everyRecharge.amount': 'Amount',
  'activity.everyRecharge.turnover': 'Turnover',
  'activity.everyRecharge.settings': 'Settings',
  'activity.everyRecharge.add': 'Add',
  'activity.everyRecharge.addNew': 'Add New',
  'activity.everyRecharge.delete': 'Delete',
  'activity.everyRecharge.cash': 'Cash',
  'activity.everyRecharge.point': 'Points',
  'activity.everyRecharge.ticket': 'Ticket',
  'activity.everyRecharge.pleaseSelect': 'Please select',
  'activity.everyRecharge.selectAwardType': 'Please select reward type',
  'activity.everyRecharge.selectTicket': 'Please select ticket',
  'activity.everyRecharge.enterMinRechargeAmount': 'Please enter minimum recharge amount',
  'activity.everyRecharge.enterMaxRechargeAmount': 'Please enter maximum recharge amount',
  'activity.everyRecharge.enterAmount': 'Please enter',
  'activity.everyRecharge.enterTurnover': 'Please enter',
  'activity.everyRecharge.amountMustBePositive': 'Amount must be greater than 0',
  'activity.everyRecharge.turnoverMustBePositive': 'Turnover must be greater than or equal to 0',
  'activity.everyRecharge.minMustLessThanMax': 'Minimum must be less than maximum',
  'activity.everyRecharge.maxMustGreaterThanMin': 'Maximum must be greater than minimum',
  'activity.everyRecharge.rangeOverlap': 'Recharge amount range cannot overlap with other tiers',
  'activity.everyRecharge.tierDescription': 'Recharge Page Description',
  'activity.everyRecharge.awardSettings': 'Award Settings',
  'activity.everyRecharge.globalDescription': 'Recharge Bonus Description',

  // First Deposit Bonus Template
  'activity.firstDeposit.configTitle': 'Deposit Bonus Config',
  'activity.firstDeposit.minRechargeAmount': 'First Deposit ≥',
  'activity.firstDeposit.maxRechargeAmount': 'First Deposit ≤',
  'activity.firstDeposit.awardType': 'Bonus Type',
  'activity.firstDeposit.amount': 'Amount',
  'activity.firstDeposit.turnover': 'Turnover',
  'activity.firstDeposit.addNew': '+ Add',
  'activity.firstDeposit.delete': 'Delete',
  'activity.firstDeposit.cash': 'Cash',
  'activity.firstDeposit.point': 'Points',
  'activity.firstDeposit.ticket': 'Ticket',
  'activity.firstDeposit.pleaseSelect': 'Please select',
  'activity.firstDeposit.selectAwardType': 'Please select bonus type',
  'activity.firstDeposit.selectTicket': 'Please select ticket',
  'activity.firstDeposit.enterMinRechargeAmount': 'Please enter minimum first deposit',
  'activity.firstDeposit.enterMaxRechargeAmount': 'Please enter maximum first deposit',
  'activity.firstDeposit.enterAmount': 'Please enter',
  'activity.firstDeposit.enterTurnover': 'Please enter',
  'activity.firstDeposit.amountMustBePositive': 'Amount must be greater than 0',
  'activity.firstDeposit.amountMustBeInteger': 'Amount must be an integer',
  'activity.firstDeposit.turnoverMustBePositive': 'Turnover multiplier must be >= 0',
  'activity.firstDeposit.minMustLessThanMax': 'Min must be less than max',
  'activity.firstDeposit.maxMustGreaterThanMin': 'Max must be greater than min',
  'activity.firstDeposit.awardSettings': 'Award Settings',
  'activity.firstDeposit.rechargePageDescription': 'Recharge Page Description',
  'activity.firstDeposit.enterDescription': 'Please enter description',
  'activity.firstDeposit.distributeMode': 'Distribute Mode',
  'activity.firstDeposit.distributeModeDirect': 'Direct to user account',
  'activity.firstDeposit.distributeModeDirectDesc': 'After first deposit, cash credited to main account, points to point account, spin tickets granted automatically',
  'activity.firstDeposit.distributeModeCoupon': 'To Promotion Center for claim',
  'activity.firstDeposit.distributeModeCouponDesc': 'After first deposit, reward appears in Promotion Center; user needs to claim manually',

  // Invite Friends Template
  'activity.invite.inviteRulesAndRewards': 'Invite Rules & Reward Settings',
  'activity.invite.inviteRulesLogic': 'Logic: For each "valid friend" generated, the inviter can manually claim the invite reward via To Claim on the client; If "Reward Invitee Simultaneously" is enabled, the invitee will automatically receive the reward upon becoming a valid user (default to main account).',
  'activity.invite.inviteRulesDetail': 'Cash: amount + turnover multiplier (required turnover = claim amount × multiplier); Points: amount only; Lucky Spin: type + quantity (multiple entries allowed).',
  'activity.invite.taskNameMultiLang': 'Invite Reward Task Name (Multi-language)',
  'activity.invite.taskNameDescription': 'Displayed according to selected languages in basic info:',
  'activity.invite.enterTaskName': 'Please enter invite reward task name',
  'activity.invite.inviterReward': 'Inviter Reward (To Claim Manual)',
  'activity.invite.inviterRewardDescription': 'Cash: amount + turnover multiplier (required turnover = claim amount × multiplier); Points: amount only; Lucky Spin: type + quantity (multiple entries allowed).',
  'activity.invite.inviteeReward': 'Reward Invitee Simultaneously (Auto Send)',
  'activity.invite.inviteeRewardDescription': 'When enabled: For each valid friend trigger, inviter generates a To Claim task; invitee automatically receives rewards configured in this column (default to main account).',
  'activity.invite.amount': 'Amount',
  'activity.invite.turnoverMultiple': 'Turnover Multiplier',
  'activity.invite.pointsNoTurnover': 'Points have no turnover requirement',
  'activity.invite.selectTicket': 'Please select ticket',
  'activity.invite.addTicketReward': 'Add Lucky Spin Reward',
  'activity.invite.achievementReward': 'Achievement Reward (Inviter)',
  'activity.invite.achievementRulesLine1': 'Rule: Achievement rewards are no longer split by currency; currency is based on basic info (PHP).',
  'activity.invite.achievementRulesLine2': 'Achievement reward "Reward Name" supports multi-language: follows basic info language settings.',
  'activity.invite.achievementLevel': 'Threshold',
  'activity.invite.rewardIcon': 'Reward Icon',
  'activity.invite.threshold': 'Threshold (Valid Friends ≥)',
  'activity.invite.enterThreshold': 'Please enter threshold',
  'activity.invite.rewardNameMultiLang': 'Reward Name (Multi-language)',
  'activity.invite.enterRewardName': 'Please enter achievement reward name',
  'activity.invite.enableCash': 'Enable',
  'activity.invite.enablePoint': 'Enable',
  'activity.invite.enableTicket': 'Enable',
  'activity.invite.addAchievementLevel': 'Add Achievement Threshold',
  'activity.invite.cashTurnoverNote': 'Cash requires turnover = cash amount × turnover multiplier; points/lucky spin only require quantity.',

  'activity.invite.rewardModeFixed': 'Fixed reward per valid member',
  'activity.invite.rewardModeFirstDeposit': 'Reward by first deposit amount range',
  'activity.invite.rewardModeHint': 'Only one mode is effective at a time. Switching only applies to members invited afterwards; already-invited members keep their original mode and config.',
  'activity.invite.inviterRewardLevel1': 'Level 1 friend (direct inviter)',
  'activity.invite.inviterRewardLevel2': 'Level 2 friend',
  'activity.invite.inviterRewardLevel3': 'Level 3 friend',
  'activity.invite.level1': 'Level 1',
  'activity.invite.level2': 'Level 2',
  'activity.invite.level3': 'Level 3',
  'activity.invite.levelN': 'Level {n}',
  'activity.invite.firstDepositIntervalTitle': 'First Deposit Amount Range Reward',
  'activity.invite.firstDepositRange': 'First Deposit Range ({{coin}})',
  'activity.invite.andAbove': 'and above',
  'activity.invite.addFirstDepositInterval': 'Add Interval',
  'activity.invite.firstDepositIntervalHint': 'Reward is based on the friend\'s first deposit amount matching an interval; intervals must not overlap or leave gaps, the highest interval has no upper bound. Cash = first deposit amount x the matched interval\'s rate for that level, capped per-level by "Max Payout Per Person".',
  'activity.invite.firstDepositCashReward': 'Cash Reward (First Deposit x Rate)',
  'activity.invite.firstDepositCap': 'Max Payout Per Person',
  'activity.invite.firstDepositCapHint': 'Capped by level, shared across all intervals; payout = min(first deposit x rate, that level\'s cap). Leaving a level at 0 means no cap for that level.',

  'activity.invite.rebateSetting': 'Rebate Settings',
  'activity.invite.rebateSettingHint': 'Rebate takes effect only when the activity is enabled, within its effective period, and this switch is on; disabling any stops new rebate calculation (already-issued rebates unaffected). Changes here only apply to members invited afterwards.',
  'activity.invite.rebateEnabled': 'Rebate Switch',
  'activity.invite.rebateLevel': 'Rebate Level',
  'activity.invite.autoIssueThreshold': 'Issuance Method',
  'activity.invite.autoIssueThresholdPrefix': 'Auto to main wallet; single cash amount ≥',
  'activity.invite.autoIssueThresholdSuffix': '{{coin}} is held pending, confirm/reject in the rebate record detail dialog',
  'activity.invite.rebateMethodDeposit': 'Deposit Rebate',
  'activity.invite.rebateMethodBet': 'Bet Rebate',
  'activity.invite.rebateMethodWinLoss': 'Win/Loss Rebate',
  'activity.invite.rebateMethodHint': 'Choose one of the four rebate methods; only one is effective at a time. After switching, all members move to the new method from the next period.',
  'activity.invite.rebateMethodNgr': 'NGR Rebate',
  'activity.invite.ngrRuleHint': 'Semi-monthly settlement (1–15 / 16–month end, paid out the day after period end). Member NGR = own GGR − own bonus received (incl. commission, full deduction) − own points-to-cash; period commission = Σ(level friends NGR) × level ratio (may be negative and offset); payable = period commission + carry-over; negative payable is not paid, carried to the next period, never deducted from balance. Ratio/multiple/threshold changes apply from the next settlement.',
  'activity.invite.ngrLevelRatio': 'Level {{n}} ratio',
  'activity.invite.ngrCashTurnoverMultiple': 'Cash turnover multiple (0 = withdrawable)',
  'activity.invite.ngrAutoIssueThreshold': 'Review threshold',
  'activity.invite.ngrAutoIssueThresholdSuffix': '{{coin}} is held pending (manual review); below threshold is issued automatically',
  'activity.invite.depositThreshold': 'Threshold (yesterday level-1 deposit total ≥ {{coin}})',
  'activity.invite.betThreshold': 'Threshold (yesterday level-1 valid bet total ≥ {{coin}})',
  'activity.invite.winLossThreshold': 'Threshold (this month level-1 net win/loss total ≥ {{coin}})',
  'activity.invite.betVenueScope': 'Qualifying Venue Scope',
  'activity.invite.rebateTierIndex': 'Tier',
  'activity.invite.addRebateTier': 'Add Tier',
  'activity.invite.rebateTierHint': 'Tiering is based on the level-1 friends\' aggregate base amount hitting the highest qualifying threshold; below the lowest threshold means no rebate this period.',
  'activity.invite.rebateFootnote': 'Base amount includes all level 1-3 friends (no validity requirement); level 4 and beyond are excluded from any reward or rebate base.',
  'activity.invite.dailyRebateCap': 'Daily Rebate Cap (By Level)',
  'activity.invite.monthlyRebateCap': 'Monthly Rebate Cap (By Level)',
  'activity.invite.rebateCapHint': 'Each level\'s cash = min(that level\'s base x that level\'s rate, that level\'s cap); anything above the cap is capped. Cash only — points/tickets/spins are unaffected. Leaving a level at 0 means no cap for that level.',

  'activity.chickActivity.userQuery.title': 'User Status Query',
  'activity.chickActivity.userQuery.userQuery': 'User Query',
  'activity.chickActivity.userQuery.userQueryPlaceholder': 'UID / Phone Number',
  'activity.chickActivity.userQuery.search': 'Search',
  'activity.chickActivity.userQuery.reset': 'Reset',
  'activity.chickActivity.userQuery.enterUserQuery': 'Please enter user UID or phone number',
  'activity.chickActivity.userQuery.userNotFound': 'User not found',
  'activity.chickActivity.userQuery.searchUserFailed': 'Failed to search user, please try again later',
  'activity.chickActivity.userQuery.queryUserStateFailed': 'Failed to query user status',
  'activity.chickActivity.userQuery.queryUserStateFailedRetry': 'Failed to query user status, please try again later',
  'activity.chickActivity.userQuery.queryRewardRecordsFailed': 'Failed to query reward records',
  'activity.chickActivity.userQuery.queryRewardRecordsFailedRetry': 'Failed to query reward records, please try again later',
  'activity.chickActivity.userQuery.stateOverview': 'Activity Status Overview',
  'activity.chickActivity.userQuery.chickState': 'Incubation Status',
  'activity.chickActivity.userQuery.energy': 'Energy',
  'activity.chickActivity.userQuery.todayBetCount': 'Today\'s Valid Bet Count',
  'activity.chickActivity.userQuery.currentPool': 'Current Pool (if any)',
  'activity.chickActivity.userQuery.currency': 'Currency:',
  'activity.chickActivity.userQuery.poolTotal': 'pool_total:',
  'activity.chickActivity.userQuery.poolRemaining': 'pool_remaining:',
  'activity.chickActivity.userQuery.chestPending': 'Chest Pending (by Currency)',
  'activity.chickActivity.userQuery.item': 'Item',
  'activity.chickActivity.userQuery.value': 'Value',
  'activity.chickActivity.userQuery.stateEnumReference': 'Status Enum Reference: EGG_INCUBATING / EGG_READY / HATCHED_NO_ENERGY / WORKING / HUNGRY / SICK',
  'activity.chickActivity.userQuery.rewardRecords': 'Reward & Check-in Records',
  'activity.chickActivity.userQuery.date': 'Date',
  'activity.chickActivity.userQuery.time': 'Time',
  'activity.chickActivity.userQuery.type': 'Type',
  'activity.chickActivity.userQuery.reward': 'Reward',
  'activity.chickActivity.userQuery.status': 'Status',
  'activity.chickActivity.userQuery.noData': 'No Data',
  'activity.chickActivity.userQuery.rewardType.depositCheckin': 'Deposit Check-in',
  'activity.chickActivity.userQuery.rewardType.freeCheckin': 'Free Check-in',
  'activity.chickActivity.userQuery.rewardType.workReward': 'Work Reward',
  'activity.chickActivity.userQuery.rewardType.energyCheckin': 'Energy Check-in',
  'activity.chickActivity.userQuery.rewardType.dailyBetMilestone': 'Bet Milestone - Daily',
  'activity.chickActivity.userQuery.rewardType.weeklyBetMilestone': 'Bet Milestone - Weekly',
  'activity.chickActivity.userQuery.rewardType.unknown': 'Type',
  'activity.chickActivity.userQuery.awardStatus.pending': 'Pending',
  'activity.chickActivity.userQuery.awardStatus.claimed': 'Claimed',
  'activity.chickActivity.userQuery.awardStatus.expired': 'Expired',
  'activity.chickActivity.userQuery.awardStatus.unknown': 'Unknown',
  'activity.chickActivity.userQuery.chickState.eggIncubating': 'Incubating',
  'activity.chickActivity.userQuery.chickState.eggReady': 'Ready to Hatch',
  'activity.chickActivity.userQuery.chickState.hatchedNoEnergy': 'Hatched No Energy',
  'activity.chickActivity.userQuery.chickState.working': 'Working',
  'activity.chickActivity.userQuery.chickState.hungry': 'Hungry',
  'activity.chickActivity.userQuery.chickState.sick': 'Sick',
  'activity.chickActivity.userQuery.chickState.idle': 'Idle',
  'activity.chickActivity.userQuery.chickState.hatching': 'Hatching',
  'activity.chickActivity.userQuery.chickState.almostHatched': 'Almost Hatched',
  'activity.chickActivity.userQuery.chickState.full': 'Full',
  'activity.chickActivity.userQuery.chickState.tired': 'Tired',
  'activity.chickActivity.userQuery.chickState.exhausted': 'Exhausted',
  'activity.chickActivity.userQuery.times': 'times',
  'activity.chickActivity.userQuery.points': 'points',

  'activity.chickActivity.report.title': 'Data Report (Summary)',
  'activity.chickActivity.report.dateRange': 'Date Range',
  'activity.chickActivity.report.selectDateRange': 'Please select date range',
  'activity.chickActivity.report.search': 'Search',
  'activity.chickActivity.report.reset': 'Reset',
  'activity.chickActivity.report.queryDataFailed': 'Failed to query data',
  'activity.chickActivity.report.queryDataFailedRetry': 'Failed to query data report, please try again later',
  'activity.chickActivity.report.statsDescription': 'Statistics Description (Frozen Requirements)',
  'activity.chickActivity.report.participantCountDesc': 'Participant Count: Deduplicated user count who entered the activity page and clicked incubation tasks or claimed rewards on the day (not by cookie).',
  'activity.chickActivity.report.depositUserCountDesc': 'Activity Deposit User Count: Deduplicated user count who participated in the activity and made at least one deposit on the day.',
  'activity.chickActivity.report.treasureBoxIssuedDesc': 'Treasure Box Issued: Cash reward amount written to treasure box on the day, counted by currency (PHP / USDT / VND).',
  'activity.chickActivity.report.treasureBoxClaimedDesc': 'Treasure Box Claimed: Cash reward amount successfully claimed from treasure box on the day, counted by currency.',
  'activity.chickActivity.report.treasureBoxExpiredDesc': 'Treasure Box Expired: Cash reward amount expired and unclaimed on the day, counted by currency (24h rule, attributed by achievement time).',
  'activity.chickActivity.report.amountPrecision': 'Amount Precision',
  'activity.chickActivity.report.amountPrecisionDesc': 'Amount Precision: Cash uniformly retains 2 decimal places, the 3rd decimal is truncated directly. Points are truncated after the decimal point.',
  'activity.chickActivity.report.date': 'Date',
  'activity.chickActivity.report.participantCount': 'Participant Count',
  'activity.chickActivity.report.depositUserCount': 'Activity Deposit User Count',
  'activity.chickActivity.report.depositCheckinClaimCount': 'Deposit Check-in Claim Count',
  'activity.chickActivity.report.depositCheckinPointsIssued': 'Deposit Check-in Points Issued',
  'activity.chickActivity.report.freeCheckinClaimCount': 'Free Check-in Claim Count',
  'activity.chickActivity.report.freeCheckinPointsIssued': 'Free Check-in Points Issued',
  'activity.chickActivity.report.energyCheckinClaimCount': 'Energy Check-in Claim Count',
  'activity.chickActivity.report.energyCheckinPointsIssued': 'Energy Check-in Points Issued',
  'activity.chickActivity.report.treasureBoxIssued': 'Treasure Box Issued',
  'activity.chickActivity.report.treasureBoxClaimed': 'Treasure Box Claimed',
  'activity.chickActivity.report.treasureBoxClaimedCount': 'Treasure Box Claimed Count',
  'activity.chickActivity.report.treasureBoxExpired': 'Treasure Box Expired',
  'activity.chickActivity.report.dailyMilestoneIssued': 'Milestone Issued (Daily)',
  'activity.chickActivity.report.dailyMilestoneClaimed': 'Milestone Claimed (Daily)',
  'activity.chickActivity.report.dailyMilestoneExpired': 'Milestone Expired (Daily)',
  'activity.chickActivity.report.weeklyMilestoneIssued': 'Milestone Issued (Weekly)',
  'activity.chickActivity.report.weeklyMilestoneClaimed': 'Milestone Claimed (Weekly)',
  'activity.chickActivity.report.weeklyMilestoneExpired': 'Milestone Expired (Weekly)',

  // New Rebate Template
  'activity.newRebate.title': 'New Betting Rebate Settings',
  'activity.newRebate.firstDepositRebate': 'First Deposit Rebate',
  'activity.newRebate.vipRebate': 'VIP Betting Rebate',
  'activity.newRebate.tieredRebate': 'Tiered Betting Rebate',
  'activity.newRebate.firstDepositAmount': 'First Deposit Amount ≥',
  'activity.newRebate.enterFirstDepositAmount': 'Please enter first deposit amount',
  'activity.newRebate.validDays': 'Valid Days',
  'activity.newRebate.enterValidDays': 'Please enter valid days',
  'activity.newRebate.rebateType': 'Rebate Type',
  'activity.newRebate.selectRebateType': 'Please select rebate type',
  'activity.newRebate.cash': 'Cash',
  'activity.newRebate.point': 'Points',
  'activity.newRebate.rebatePercent': 'Rebate Ratio',
  'activity.newRebate.enterRebatePercent': 'Please enter rebate ratio',
  'activity.newRebate.truncateNotice': 'Rebate ratio supports up to 2 decimal places. Rebate amounts keep 2 decimal places with the excess truncated (no rounding); awards below 0.01 are discarded and not distributed. Applies to cash rebates of First Deposit / VIP / Tiered betting rebate; point rebates are not affected.',
  'activity.newRebate.maxRebateCash': 'Daily Max Rebate Cash',
  'activity.newRebate.maxRebatePoint': 'Max Rebate Points',
  'activity.newRebate.enterMaxRebate': 'Please enter max rebate amount',
  'activity.newRebate.turnover': 'Turnover Multiplier',
  'activity.newRebate.enterTurnover': 'Please enter turnover',
  'activity.newRebate.vipLevel': 'VIP Level',
  'activity.newRebate.selectVipLevel': 'Please select VIP level',
  'activity.newRebate.bettingTurnover': 'Betting Turnover ≥',
  'activity.newRebate.enterBettingTurnover': 'Please enter betting turnover',
  'activity.newRebate.vipLevelMin': 'Min Level',
  'activity.newRebate.vipLevelMax': 'Max Level',
  'activity.newRebate.addRule': 'Add',
  'activity.newRebate.deleteRule': 'Delete',
  'activity.newRebate.gamePlatform': 'Game Platform',
  'activity.newRebate.ruleIndex': 'Rule {{index}}',
  'activity.newRebate.tierIndex': 'Tier {{index}}',
  'activity.newRebate.atLeastOneRule': 'At least one configuration (cash or points) is required',
  'activity.newRebate.maxRuleLimit': 'Only one cash and one points configuration allowed',
  'activity.newRebate.vipLevelConflict': 'This VIP level is already used by another configuration',
  'activity.newRebate.duplicateTurnoverType': 'A configuration with the same rebate type already exists for this turnover tier',
  'activity.newRebate.atLeastOneGameType': 'At least one game type must be selected',
  'activity.newRebate.gameType.1': 'Slots',
  'activity.newRebate.gameType.2': 'Live Casino',
  'activity.newRebate.gameType.3': 'Sports',
  'activity.newRebate.gameType.4': 'Lottery',
  'activity.newRebate.gameType.5': 'Fishing',
  'activity.newRebate.gameType.6': 'Card & Board',
  'activity.newRebate.gameType.7': 'eSports',
  'activity.newRebate.gameType.8': 'Mini Games',
  'activity.newRebate.gameType.9': 'Prediction',
  'activity.newRebate.gameType.10': 'eSports',
  'activity.newRebate.gameType.11': 'Arcade',
  'activity.newRebate.gameType.12': 'Bingo',
  'activity.newRebate.distributeMode': 'Distribution Method',
  'activity.newRebate.distributeModeDirect': 'Distribute directly to user account',
  'activity.newRebate.distributeModeDirectDesc': 'On rebate settlement, cash credits the main account and points credit the points account automatically',
  'activity.newRebate.distributeModeCoupon': 'Distribute to Promotion Center for claim',
  'activity.newRebate.distributeModeCouponDesc': 'On rebate settlement, the reward appears in the Promotion Center and is credited after the user claims it manually',

  'activity.newRebate.gameGroupRebate': 'Game Group Rebate',
  'activity.newRebate.gameGroup.create': '+ New Game Group',
  'activity.newRebate.gameGroup.createTitle': 'New Game Group',
  'activity.newRebate.gameGroup.syncIcons': 'Sync Game Icons',
  'activity.newRebate.gameGroup.syncIconsTooltip': 'Pull default-language langGame.h5Img from the dispset game library and write it back to iconUrl on every selectable game. The front-end daily-stats games[].iconUrl is sourced from this column.',
  'activity.newRebate.gameGroup.syncIconsConfirmTitle': 'Sync icons for all selectable games?',
  'activity.newRebate.gameGroup.syncIconsConfirmContent': 'Default-language h5Img will be fetched in batch; only rows whose icon differs from the old value will be written. Usually finishes in under 5 seconds.',
  'activity.newRebate.gameGroup.syncIconsRunning': 'Syncing…',
  'activity.newRebate.gameGroup.syncIconsResultTitle': 'Sync finished',
  'activity.newRebate.gameGroup.syncIconsSummary': 'Total {{total}} / Matched {{matched}} / Updated {{updated}} / Skipped {{skipped}}',
  'activity.newRebate.gameGroup.syncIconsSkippedTitle': 'Skipped items (ask ops to fill h5Img on the default language in the game library)',
  'activity.newRebate.gameGroup.syncIconsSkippedColPlatform': 'Platform',
  'activity.newRebate.gameGroup.syncIconsSkippedColGameCode': 'Game Code',
  'activity.newRebate.gameGroup.syncIconsSkippedColReason': 'Reason',
  'activity.newRebate.gameGroup.syncIconsFailed': 'Sync failed, please check network or backend logs',
  'activity.newRebate.gameGroup.iconNotSynced': 'Icon not synced. Click "Sync Game Icons" to back-fill in batch.',
  'activity.newRebate.gameGroup.iconLoadFailed': 'Icon URL is synced but failed to load (likely 404 or bad path). Ask ops to verify h5Img in the game library.',
  'activity.newRebate.gameGroup.editTitle': 'Edit Game Group',
  'activity.newRebate.gameGroup.basicInfo': 'Basic Info',
  'activity.newRebate.gameGroup.gamesInGroup': 'Games in Group',
  'activity.newRebate.gameGroup.gamesInGroupHint': 'A game can only belong to one group at a time; occupied games are greyed out.',
  'activity.newRebate.gameGroup.name': 'Group Name',
  'activity.newRebate.gameGroup.namePlaceholder': 'e.g. New Game Spotlight · PG',
  'activity.newRebate.gameGroup.coverImg': 'Cover',
  'activity.newRebate.gameGroup.coverImgPlaceholder': 'Recommended 120×120 JPG/PNG, paste image URL',
  'activity.newRebate.gameGroup.coverImgHint': 'Recommended 120×120 JPG/PNG/WEBP, max 2MB per image',
  'activity.newRebate.gameGroup.startDate': 'Start date',
  'activity.newRebate.gameGroup.endDate': 'End date',
  'activity.newRebate.gameGroup.percent': 'Rebate %',
  'activity.newRebate.gameGroup.percentPlaceholder': 'Enter rebate %',
  'activity.newRebate.gameGroup.maxRebate': 'Daily Cap',
  'activity.newRebate.gameGroup.maxRebatePlaceholder': 'Enter daily cap',
  'activity.newRebate.gameGroup.turnoverMultiplier': 'Turnover ×',
  'activity.newRebate.gameGroup.turnoverMultiplierPlaceholder': 'Enter turnover multiplier',
  'activity.newRebate.gameGroup.timeRange': 'Limited Time',
  'activity.newRebate.gameGroup.timeRangeHint': 'Optional; leave empty for permanent. When set, auto online at start, auto offline at end.',
  'activity.newRebate.gameGroup.sortNo': 'Sort',
  'activity.newRebate.gameGroup.searchGame': 'Search game name…',
  'activity.newRebate.gameGroup.expandAll': 'Expand All',
  'activity.newRebate.gameGroup.collapseAll': 'Collapse All',
  'activity.newRebate.gameGroup.selectAllPlatform': 'Select All',
  'activity.newRebate.gameGroup.gamesCount': '{{count}} games',
  'activity.newRebate.gameGroup.selectedCount': '{{count}} games selected',
  'activity.newRebate.gameGroup.occupied': 'Occupied',
  'activity.newRebate.gameGroup.atLeastOneGame': 'Please select at least one game',
  'activity.newRebate.gameGroup.emptySource': 'No selectable games yet. Please add games in the Game Pool first.',
  'activity.newRebate.gameGroup.noMatchedGame': 'No matched games',
  'activity.newRebate.gameGroup.emptyList': 'No game group configured yet',
  'activity.newRebate.gameGroup.listSubtitle': "Operations team can create groups freely; group's bets only count toward this group, not into tiered rebate.",
  'activity.newRebate.gameGroup.tipDeduct': "Flow attribution (core rule): Bets on games inside any group only count toward that group, NOT toward the tiered rebate of their game type (Slot/Live/Sport/Fish).",
  'activity.newRebate.gameGroup.tipUnique': 'Unique ownership: A game can only belong to one group at a time. Games occupied by other groups are marked "Occupied" and disabled in the modal.',
  'activity.newRebate.gameGroup.tipDeductTitle': 'Flow attribution (core rule)',
  'activity.newRebate.gameGroup.tipDeductDesc': 'Bets on games inside any group only count toward that group, NOT toward the tiered rebate of their game type (Slot/Live/Sport/Fish).',
  'activity.newRebate.gameGroup.tipUniqueTitle': 'Unique ownership',
  'activity.newRebate.gameGroup.tipUniqueDesc': 'A game can only belong to one group at a time. Games occupied by other groups are marked "Occupied" and disabled in the modal.',
  'activity.newRebate.gameGroup.noCover': 'No Cover',
  'activity.newRebate.gameGroup.longTerm': 'Permanent',
  'activity.newRebate.gameGroup.status': 'Status',
  'activity.newRebate.gameGroup.statusOf.online': 'Online',
  'activity.newRebate.gameGroup.statusOf.upcoming': 'Upcoming',
  'activity.newRebate.gameGroup.statusOf.offline': 'Offline',
  'activity.newRebate.gameGroup.statusOf.manualOff': 'Manually Off',
  'activity.newRebate.gameGroup.operation': 'Action',
  'activity.newRebate.gameGroup.edit': 'Edit',
  'activity.newRebate.gameGroup.delete': 'Delete',
  'activity.newRebate.gameGroup.unpublish': 'Unpublish',
  'activity.newRebate.gameGroup.publish': 'Publish',
  'activity.newRebate.gameGroup.deleteConfirm': 'Delete this game group?',
  'activity.newRebate.gameGroup.deleteSuccess': 'Deleted',
  'activity.newRebate.gameGroup.confirmOk': 'OK',
  'activity.newRebate.gameGroup.cancel': 'Cancel',
  'activity.newRebate.gameGroup.save': 'Save',

  // Info Binding Template translations
  'activity.infoBinding.conditionSettings': 'Condition Settings',
  'activity.infoBinding.serialNumber': 'Serial Number',
  'activity.infoBinding.enterSerialNumber': 'Please enter serial number',
  'activity.infoBinding.serialNumberMustBePositive': 'Serial number must be greater than 0',
  'activity.infoBinding.authInfoType': 'When authentication info =',
  'activity.infoBinding.selectAuthInfoType': 'Please select authentication info',
  'activity.infoBinding.authInfo.mobileTask': 'Mobile Verification Task and Reward',
  'activity.infoBinding.authInfo.emailTask': 'Email Verification Task and Reward',
  'activity.infoBinding.authInfo.withdrawPasswordTask': 'Withdraw Password Task and Reward',
  'activity.infoBinding.authInfo.kycTask': 'KYC Task and Reward',
  'activity.infoBinding.authInfo.downloadAppTask': 'Download APP Task and Reward',
  'activity.infoBinding.authInfo.appLoginMobileVerifiedTask': 'APP Login Success and Mobile Verified',
  'activity.infoBinding.excludeMember.title': 'No-Reward Member List',
  'activity.infoBinding.excludeMember.manage': 'Manage Exclusion List',
  'activity.infoBinding.excludeMember.memberAccount': 'Member Account',
  'activity.infoBinding.excludeMember.createUserName': 'Operator',
  'activity.infoBinding.excludeMember.createTime': 'Create Time',
  'activity.infoBinding.excludeMember.searchPlaceholder': 'Search by account',
  'activity.infoBinding.excludeMember.upload': 'Upload CSV',
  'activity.infoBinding.excludeMember.uploadTitle': 'Batch Import Excluded Accounts',
  'activity.infoBinding.excludeMember.downloadTemplate': 'Download Template',
  'activity.infoBinding.excludeMember.uploadHint': 'CSV format: first row is header (memberAccount), subsequent rows are accounts',
  'activity.infoBinding.excludeMember.deleteSuccess': 'Deleted successfully',
  'activity.infoBinding.excludeMember.uploadSuccess': 'Uploaded successfully',
  'activity.infoBinding.excludeMember.operation': 'Operation',
  'activity.infoBinding.excludeMember.deleteConfirm': 'Confirm delete this record?',
  'activity.infoBinding.excludeMember.confirmOk': 'Confirm',
  'activity.infoBinding.excludeMember.delete': 'Delete',
  'activity.infoBinding.excludeMember.search': 'Search',
  'activity.infoBinding.excludeMember.total': 'Total',
  'activity.infoBinding.excludeMember.saveFirst': 'Please save the activity first before managing the list',
  'activity.infoBinding.rewardDistribution': 'Then Distribute',
  'activity.infoBinding.rewardType': 'Reward Type',
  'activity.infoBinding.pointAmount': 'Points Amount',
  'activity.infoBinding.enterPointAmount': 'Please enter points amount',
  'activity.infoBinding.pointAmountMustBePositive': 'Points amount must be greater than 0',
  'activity.infoBinding.addPointReward': 'Add Point Reward',
  'activity.infoBinding.cashAmount': 'Cash Amount',
  'activity.infoBinding.enterCashAmount': 'Please enter cash amount',
  'activity.infoBinding.cashAmountMustBeNonNegative': 'Cash amount cannot be negative',
  'activity.infoBinding.desireMultiple': 'Turnover Multiple',
  'activity.infoBinding.enterDesireMultiple': 'Please enter turnover multiple',
  'activity.infoBinding.cashRequiresMultiple': 'Turnover multiple is required when cash reward is greater than 0',
  'activity.infoBinding.addCashReward': 'Add Cash Reward',
  'activity.infoBinding.otherSettings': 'Other Settings',
  'activity.infoBinding.riskControlConditions': 'Risk Control Conditions',
  'activity.infoBinding.selectRiskControlLevel': 'Select Risk Control Level',
  'activity.infoBinding.taskSwitch': 'Task Switch',
  'activity.infoBinding.selectAuthType': 'Select Task Type',
  'activity.infoBinding.selectAuthTypePlaceholder': 'Please select task type',
  'activity.infoBinding.selectAuthTypeFirst': 'Please select task type first',

  // Chick Activity
  'chickActivity.activityConfig': 'Activity Configuration',
  'chickActivity.dataReport': 'Data Report',
  'chickActivity.userQuery': 'User Status Query',

  // Activity Configuration Page
  'chickActivity.activityBasic': 'Activity Basic',
  'chickActivity.activityStatus': 'Activity Status',
  'chickActivity.enabled': 'Enabled',
  'chickActivity.disabled': 'Disabled',
  'chickActivity.enabledHint': 'Effective for all users after enabled',
  'chickActivity.activityTime': 'Activity Time',
  'chickActivity.userScope': 'User Scope',
  'chickActivity.userScopeDesc': 'All users (create egg and participate when login during activity period)',
  'chickActivity.readonly': 'Read Only',
  'chickActivity.autoHatchTime': 'Auto Hatch Time',
  'chickActivity.autoHatchTimeDesc': '72 hours (auto hatch when timeout, energy=0)',
  'chickActivity.systemDefault': 'System Default',
  'chickActivity.systemRules': 'System Rules (Read Only)',
  'chickActivity.systemRule1': 'Total stamina is 7 slots; on the day of deposit, it recovers to full; if no deposit is made daily, -1.',
  'chickActivity.systemRule2': 'Stamina 4-7 can trigger work rebates; if stamina is 0 (Sick), free check-in appears.',
  'chickActivity.systemRule3': 'Each deposit generates a new rebate pool (pool_total recalculated), and corresponding work rewards are recalculated.',
  'chickActivity.systemRule4': 'Treasure chest rewards are valid for 24 hours; if not claimed, they expire.',
  'chickActivity.systemRule5': 'Cross-day entry criteria: If achieved on the current day but written into the treasure chest on the next day, it still belongs to the achievement day; validity starts from the achievement time for 24 hours.',
  'chickActivity.systemRule6': 'Amount precision: retain 2 decimal places, the 3rd digit is directly truncated (no rounding).',
  'chickActivity.globalRebateRatio': 'Global Rebate Ratio',
  'chickActivity.globalRebateRatioExample': 'Example: Deposit 1000P → pool_total = 8P',
  'chickActivity.workPoolRebateRatio': 'Work Pool Rebate Ratio (%)',
  'chickActivity.workPoolRebateRatioDesc': 'Each Deposit × This Ratio = New Pool pool_total',
  'chickActivity.poolMaxAmount': 'Pool Max Amount',
  'chickActivity.poolMaxAmountDesc': 'Max pool amount per deposit (capped if exceeded)',
  'chickActivity.workPoolRatio': 'Reward Unlock Condition (Accumulated Bet Ratio)',
  'chickActivity.workPoolRatioExample': 'Trigger work reward after accumulated valid bet ≥ Pool × X%',
  'chickActivity.rewardTurnoverMultiple': 'Reward Cash Turnover Multiple',
  'chickActivity.rewardTurnoverMultipleDesc': 'Turnover requirement for cash reward withdrawal (multiple)',

  // Hatch Tasks
  'chickActivity.hatchTasks': 'Hatch Tasks',
  'chickActivity.taskOnceOnly': 'Each task can only be completed once',
  'chickActivity.hatchTaskDesc': 'Task name shows multi-language edit entry; reward is hours to reduce hatching time.',
  'chickActivity.taskNameMultiLang': 'Task Name (Multi-language)',
  'chickActivity.taskName': 'Task Name',
  'chickActivity.enterTaskName': 'Enter task name',
  'chickActivity.taskDesc': 'Task Description',
  'chickActivity.enterTaskDesc': 'Enter task description',
  'chickActivity.editTaskName': 'Edit Task Name (Multi-language)',
  'chickActivity.rewardHours': 'Reward (Reduce Hatch Time)',
  'chickActivity.directHatch': 'Direct Hatch (System Rule)',
  'chickActivity.hours': 'hours',
  'chickActivity.completionCondition': 'Completion Condition (Read Only)',
  // Completion condition by taskKey (shared by hatch tasks and energy tasks)
  'chickActivity.taskCondition.bind_phone': 'Complete one phone number binding',
  'chickActivity.taskCondition.bind_email': 'Complete one email binding',
  'chickActivity.taskCondition.kyc_verify': 'Complete one KYC verification',
  'chickActivity.taskCondition.name_chick': 'Name the chick for the first time',
  'chickActivity.taskCondition.app_login': 'Complete an APP login',
  'chickActivity.taskCondition.first_deposit': 'Complete the first deposit',
  'chickActivity.taskCondition.invite_valid_friend': 'Invite a valid friend',

  // Energy Tasks
  'chickActivity.energyTasks': 'Energy Tasks',
  'chickActivity.energyTaskDesc': 'Energy task configuration, supports one-time and daily tasks. Reward is energy value.',
  'chickActivity.energyTaskType': 'Task Type',
  'chickActivity.energyTaskTypeOnce': 'One-time Task',
  'chickActivity.energyTaskTypeDaily': 'Daily Task',
  'chickActivity.rewardEnergy': 'Reward Energy',
  'chickActivity.energyUnit': 'Energy',
  'chickActivity.rewardPoints': 'Reward Points',

  // Deposit Check-in
  'chickActivity.depositCheckin': 'Deposit Check-in (7 Days Energy)',
  'chickActivity.currentCurrency': 'Current Currency',
  'chickActivity.addTier': 'Add Tier',
  'chickActivity.addWorkTier': 'Add Tier',
  'chickActivity.depositCheckinDesc': 'Total Reward = Deposit Amount × (Tier "7-Day Energy Reward Ratio") → Split by D1-D7 curve (Total=100%).',
  'chickActivity.amountTruncate': 'Amount truncation: Keep 2 decimal places, truncate 3rd place directly. Highest tier can configure "Point Cap" (only highest tier effective).',
  'chickActivity.depositRange': 'Deposit Range',
  'chickActivity.rewardRatio': '7-Day Energy Reward Ratio (%)',
  'chickActivity.pointCap': 'Max Point Cap (Highest Tier Only)',
  'chickActivity.range': 'Range',
  'chickActivity.total': 'Total',
  'chickActivity.tierNote': 'Adding/deleting tiers will sync affect D1-D7 curve rows; tiers and curves of different currencies are independent.',

  // Free Check-in
  'chickActivity.freeCheckin': 'Free Check-in (Sick)',
  'chickActivity.freeCheckinDesc': 'Disable effect: Free check-in entry will not appear when energy=0; does not affect deposit check-in and work rewards.',
  'chickActivity.triggerCondition': 'Trigger Condition',
  'chickActivity.sickCondition': 'Energy = 0 (Sick)',
  'chickActivity.systemRule': 'System Rule',
  'chickActivity.dailyLimit': 'Daily Limit',
  'chickActivity.times': 'times',
  'chickActivity.rewardRange': 'Reward Range',
  'chickActivity.serverRandom': 'Random by server',
  'chickActivity.readonlyDisplay': 'Read Only Display',
  'chickActivity.restoreEnergy': 'Restore Energy',
  'chickActivity.no': 'No',
  'chickActivity.fixed': 'Fixed',

  // Work Reward
  'chickActivity.workReward': 'Work Reward (Milestone)',
  'chickActivity.poolTriggerOnce': 'Trigger once per pool',
  'chickActivity.workRewardDesc': 'Completion condition: Daily accumulated valid bet count ≥ N times, trigger once; award highest tier.',
  'chickActivity.workRewardDesc2': 'Drop count per tier is fixed at 1; recalculate triggerable tiers after each deposit creates new pool.',
  'chickActivity.workRewardDescNew1': 'Each deposit generates a new work pool, and starts accumulating reward unlock conditions from "pool generation time", then calculates valid bet count.',
  'chickActivity.workRewardDescNew2': 'Milestones are [Tiered]: Upon completing each tier, the tier reward is issued (default 1 drop); each tier triggers only once.',
  'chickActivity.workRewardDescNew3': 'After another deposit, the pool refreshes with the new deposit amount, and bet count resets to 0.',
  'chickActivity.workCondition': 'Completion Condition (Daily Accumulated ≥ N times)',
  'chickActivity.accumulateReach': 'Accumulated Reach',
  'chickActivity.dropCount': 'Drop Count',
  'chickActivity.rewardType': 'Reward Distribution Type',
  'chickActivity.cash': 'Cash',
  'chickActivity.points': 'Points',
  'chickActivity.poolToPointsRatio': 'Prize Pool to Points Ratio',
  'chickActivity.cashToPointsRate': 'Points per 1 Unit Cash',
  'chickActivity.useGlobal': 'Use Global',
  'chickActivity.tierRateModalDesc': 'Leave empty to use global settings, set custom exchange rate for this tier',
  'chickActivity.workRewardTotalError': 'Work Reward (Milestone) total ratio must be 100%, current is {total}%',
  'chickActivity.depositCurveTotalError': 'Deposit check-in curve validation failed:\n{errors}',

  // Jeepney Activity
  'jeepneyActivity.activityStatus': 'Activity Status',
  'jeepneyActivity.selectActivityStatus': 'Please select activity status',
  'jeepneyActivity.enabled': 'Enabled',
  'jeepneyActivity.disabled': 'Disabled',
  'jeepneyActivity.currency': 'Currency',
  'jeepneyActivity.selectCurrency': 'Please select currency',
  'jeepneyActivity.activityTime': 'Activity Start/End Time',
  'jeepneyActivity.selectActivityTime': 'Please select activity start/end time',
  'jeepneyActivity.rewardExpireDays': 'Reward Expiry Days',
  'jeepneyActivity.rewardExpireDaysPlaceholder': 'Enter days, -1 means no expiry',
  'jeepneyActivity.enterRewardExpireDays': 'Please enter reward expiry days',
  'jeepneyActivity.days': 'Days',
  'jeepneyActivity.riskControlLevel': 'Risk Control Level',
  'jeepneyActivity.selectRiskControlLevel': 'Select risk control level',
  'jeepneyActivity.riskControl.restrictLogin': 'Restrict Login',
  'jeepneyActivity.riskControl.restrictDeposit': 'Restrict Deposit',
  'jeepneyActivity.riskControl.restrictClaim': 'Restrict Claim Optimization',
  'jeepneyActivity.riskControl.suspectedRisk': 'Suspected Risk',
  'jeepneyActivity.riskControl.sameIpControl': 'Same IP Control',
  'jeepneyActivity.multiLanguage': 'Multi-language',
  'jeepneyActivity.basicSettings': 'Basic Settings',
  'jeepneyActivity.activityName': 'Activity Name',
  'jeepneyActivity.enterActivityName': 'Please enter activity name',
  'jeepneyActivity.promotionName': 'Promotion Name',
  'jeepneyActivity.detailUrl': 'Detail URL',
  'jeepneyActivity.enterDetailUrl': 'Please enter detail URL',
  'jeepneyActivity.activityIntroduction': 'Activity Introduction',
  'jeepneyActivity.enterActivityIntroduction': 'Please enter activity introduction',
  'jeepneyActivity.appIcon': 'APP Icon',
  'jeepneyActivity.selectAppIcon': 'Please upload APP icon',
  'jeepneyActivity.h5Icon': 'H5 Icon',
  'jeepneyActivity.selectH5Icon': 'Please upload H5 icon',
  'jeepneyActivity.pcIcon': 'PC Icon',
  'jeepneyActivity.selectPcIcon': 'Please upload PC icon',
  'jeepneyActivity.imageUploadTip': 'Standard size 700*280 width, supports .jpg .jpeg .png, max 2M',
  
  // Track and Reward Settings
  'jeepneyActivity.trackAndRewardSettings': 'Track and Reward Settings',
  'jeepneyActivity.basicInfo': 'Basic Information',
  'jeepneyActivity.totalStages': 'Total Stages',
  'jeepneyActivity.totalStagesRequired': 'Please enter total stages',
  'jeepneyActivity.totalStagesPlaceholder': 'Please enter total stages',
  'jeepneyActivity.totalStagesTip': 'The last stage is the final stage (no need to configure final stage number separately)',
  'jeepneyActivity.totalStagesTimeLimit': 'Total Stages Time Limit',
  'jeepneyActivity.sectionEndStages': 'Section End Stages',
  'jeepneyActivity.sectionEndStagesPlaceholder': 'Please select section end stages',
  'jeepneyActivity.sectionEndStagesTip': 'Section end stages are used to trigger "Section End Default Reward" and "Section End Preview Popup". After manual selection, the section end stages in the table will be marked',
  'jeepneyActivity.cashOutEnabledStages': 'Cash Out Enabled Stages',
  'jeepneyActivity.cashOutEnabledStagesPlaceholder': 'Please enter cash out enabled stages',
  'jeepneyActivity.finalStageConsumption': 'Final Stage Consumption',
  'jeepneyActivity.finalStageConsumptionPlaceholder': 'Please enter final stage consumption',
  'jeepneyActivity.currencyAcquisitionMethods': 'Currency Acquisition Methods',
  'jeepneyActivity.currencyAcquisitionMethod': 'Currency Acquisition Method',
  'jeepneyActivity.currencyMethod.invite': 'Invite Fuel',
  'jeepneyActivity.currencyMethod.pointsExchange': 'Points Exchange',
  'jeepneyActivity.currencyMethod.recharge': 'Recharge Exchange',
  'jeepneyActivity.stages': 'Stages',
  'jeepneyActivity.exchangeRatio': 'Exchange Ratio',
  'jeepneyActivity.minRechargeAmount': 'Recharge Amount ≥',
  'jeepneyActivity.rewardValueType': 'Value Method',
  'jeepneyActivity.rewardValueTypeRequired': 'Please select value method',
  'jeepneyActivity.rewardValueType.fixed': 'Fixed Distribution',
  'jeepneyActivity.rewardValueType.random': 'Random Distribution',
  'jeepneyActivity.value': 'Value',
  'jeepneyActivity.currencyName': 'Currency Name',
  'jeepneyActivity.currencyNameRequired': 'Please enter currency name',
  'jeepneyActivity.currencyNamePlaceholder': 'Please enter currency name',
  'jeepneyActivity.buttonName': 'Button Name',
  'jeepneyActivity.buttonNameRequired': 'Please enter button name',
  'jeepneyActivity.buttonNamePlaceholder': 'Please enter button name',
  'jeepneyActivity.singleRoundCashCap': 'Single Round Cash Cap',
  'jeepneyActivity.currencyRequired': 'Please select currency',
  'jeepneyActivity.amountRequired': 'Please enter amount',
  'jeepneyActivity.amount': 'Amount',
  'jeepneyActivity.stageConfig': 'Stage Configuration',
  'jeepneyActivity.stageNumber': 'Stage Number',
  'jeepneyActivity.stageType': 'Stage Type',
  'jeepneyActivity.stageType.normal': 'Normal',
  'jeepneyActivity.stageType.sectionEnd': 'Section End',
  'jeepneyActivity.stageType.final': 'Final',
  'jeepneyActivity.configSource': 'Reward Source',
  'jeepneyActivity.configSource.default': 'Default Config',
  'jeepneyActivity.configSource.manual': 'Manual Config',
  'jeepneyActivity.rewardType': 'Reward Type',
  'jeepneyActivity.rewardType.fixed': 'Fixed',
  'jeepneyActivity.rewardType.random': 'Random',
  'jeepneyActivity.rewardContent': 'Reward Content',
  'jeepneyActivity.notConfigured': 'Not Configured',
  'jeepneyActivity.accumulatedConsumption': 'Accumulated Consumption',
  'jeepneyActivity.actualConsumption': 'Actual Consumption (Difference)',
  'jeepneyActivity.distributionMethod': 'Distribution Method',
  'jeepneyActivity.distributionMethod.all': 'Distribute All Awards',
  'jeepneyActivity.distributionMethod.randomOne': 'Randomly Distribute One Award',
  'jeepneyActivity.cashOutEnabled': 'Redeem this level\'s reward',
  'jeepneyActivity.defaultRewardSettings': 'Default Stage Settings',
  'jeepneyActivity.singleRoundPointsCap': 'Single Round Points Cap',
  'jeepneyActivity.singleRoundPointsCapRequired': 'Please enter single round points cap',
  'jeepneyActivity.singleRoundPointsCapPlaceholder': 'Please enter single round points cap',
  'jeepneyActivity.singleRoundVoucherCap': 'Single Round Single Voucher Cap',
  'jeepneyActivity.singleRoundVoucherCapRequired': 'Please enter single round single voucher cap',
  'jeepneyActivity.singleRoundVoucherCapPlaceholder': 'Please enter single round single voucher cap',
  'jeepneyActivity.singleRoundFuelCap': 'Single Round Fuel Cap',
  'jeepneyActivity.singleRoundFuelCapRequired': 'Please enter single round fuel cap',
  'jeepneyActivity.singleRoundFuelCapPlaceholder': 'Please enter single round fuel cap',
  'jeepneyActivity.sectionEndStagesRequired': 'Please select section end stages',
  'jeepneyActivity.minimumParticipationThreshold': 'Minimum Participation Threshold',
  'jeepneyActivity.minimumParticipationThresholdRequired': 'Please enter minimum participation threshold',
  'jeepneyActivity.minimumParticipationThresholdPlaceholder': 'Please enter minimum participation threshold',
  'jeepneyActivity.globalCashTurnoverMultiplier': 'Global Cash Turnover Multiplier',
  'jeepneyActivity.globalCashTurnoverMultiplierRequired': 'Please enter global cash turnover multiplier',
  'jeepneyActivity.globalCashTurnoverMultiplierPlaceholder': 'Please enter global cash turnover multiplier',
  'jeepneyActivity.countdownSettings': 'Countdown Settings',
  'jeepneyActivity.countdownRuleTip': 'Within the limited-time increased countdown, if no timed tasks are completed, the next round will restart.',
  'jeepneyActivity.timedTaskCountdown': 'Timed Task Countdown',
  'jeepneyActivity.duration': 'Duration',
  'jeepneyActivity.durationRequired': 'Please enter countdown duration',
  'jeepneyActivity.hours': 'Hours',
  'jeepneyActivity.minutes': 'Minutes',
  'jeepneyActivity.seconds': 'Seconds',
  'jeepneyActivity.allowAllCompletion': 'Allow All Completion',
  'jeepneyActivity.allowAllCompletionTip': 'If turned off, completing one task will cause this task entry to disappear; at the end of the next countdown, entirely new tasks will be displayed.',
  'jeepneyActivity.rechargeTasks': 'Recharge Tasks',
  'jeepneyActivity.rechargeAmount': 'Recharge Amount ≥',
  'jeepneyActivity.timeIncrease': 'Countdown Increase',
  'jeepneyActivity.timeIncreaseRequired': 'Please enter countdown increase',
  'jeepneyActivity.inviteTasks': 'Invite Tasks',
  'jeepneyActivity.inviteFriends': 'Invite Friends',
  'jeepneyActivity.inviteFriendType': 'Invite Friend Type',
  'jeepneyActivity.inviteValidFriends': 'Valid Friends',
  'jeepneyActivity.inviteRegisteredFriends': 'Registered Friends',
  'jeepneyActivity.registeredUsers': 'Registered Users',
  'jeepneyActivity.peopleCount': 'People Count',
  'jeepneyActivity.peopleCountRequired': 'Please enter people count',
  'jeepneyActivity.rewardValuePerInstance': 'Reward Value Per Instance',
  'jeepneyActivity.rewardValue': 'Reward Value',
  'jeepneyActivity.pointsExchange': 'Points Exchange',
  'jeepneyActivity.consumePoints': 'Consume Points',
  'jeepneyActivity.consumePointsRequired': 'Please enter consume points',
  'jeepneyActivity.dailyPurchaseLimit': 'Daily Purchase Limit',
  'jeepneyActivity.dailyPurchaseLimitRequired': 'Please enter daily purchase limit',
  'jeepneyActivity.testRechargeCount': 'Test Recharge Count',
  'jeepneyActivity.testInviteCount': 'Test Invite Count',
  'jeepneyActivity.unit': 'Unit',
  'jeepneyActivity.unitRequired': 'Please select unit',
  'jeepneyActivity.validFriends': 'Invite Valid Friends',
  'jeepneyActivity.validFriendsRequired': 'Please enter number of valid friends',
  'jeepneyActivity.countdownConfigTip': 'When configuring operations, avoid setting multiple similar thresholds to prevent a confusing experience (it is recommended that thresholds are clear and time differences are distinct).',
  'jeepneyActivity.fuelConsumptionWarning': 'Modifications in the table will update all subsequent accumulated consumption values based on the current stage\'s entered value, and recalculate actual consumption',
  'jeepneyActivity.pleaseSetTotalStages': 'Please set total stages first',
  'jeepneyActivity.defaultRewardConfig': 'Default Stage Settings',
  'jeepneyActivity.entryReward': 'Entry Reward',
  'jeepneyActivity.entryRewardApplied': 'Entry Reward Applied Content',
  'jeepneyActivity.notSet': 'Not Set',
  'jeepneyActivity.defaultReward': 'Stage Settings',
  'jeepneyActivity.rewardConfig': 'Reward Configuration',
  'jeepneyActivity.rewardTypeDuplicate.points': 'Points can only appear once',
  'jeepneyActivity.rewardTypeDuplicate.fuel': 'Fuel can only appear once',
  'jeepneyActivity.cashCurrencyDuplicate': 'Cash with the same currency can only appear once',
  'jeepneyActivity.ticketTypeDuplicate': 'Turntable of the same type can only appear once',
  'jeepneyActivity.rewardTypeRequired': 'Please select reward type',
  'jeepneyActivity.rewardType.cash': 'Cash',
  'jeepneyActivity.rewardType.points': 'Points',
  'jeepneyActivity.rewardType.spinTicket': 'Spin Ticket',
  'jeepneyActivity.rewardType.fuel': 'Fuel',
  'jeepneyActivity.rewardType.none': 'None',
  'jeepneyActivity.turntableType': 'Turntable Type',
  'jeepneyActivity.turntableTypeRequired': 'Please select turntable type',
  'jeepneyActivity.turntable1': 'Turntable 1',
  'jeepneyActivity.turntable2': 'Turntable 2',
  'jeepneyActivity.rewardValueType': 'Reward Value Type',
  'jeepneyActivity.valueRequired': 'Please enter value',
  'jeepneyActivity.minValue': 'Min Value',
  'jeepneyActivity.minValueRequired': 'Please enter min value',
  'jeepneyActivity.maxValue': 'Max Value',
  'jeepneyActivity.maxValueRequired': 'Please enter max value',
  'jeepneyActivity.defaultRewardWarning': 'Note: The client\'s one-click advancement button must advance 1 level, to avoid clicking without movement, if not configured, the game cannot be played',
  'jeepneyActivity.currencyConsumptionStrategy': 'Currency Consumption Strategy',
  'jeepneyActivity.rewardDistributionStrategy': 'Reward Distribution Strategy',
  'jeepneyActivity.startingConsumption': 'Starting Consumption',
  'jeepneyActivity.startingConsumptionRequired': 'Please enter starting consumption',
  'jeepneyActivity.incrementalStep': 'Incremental Step',
  'jeepneyActivity.incrementalStepRequired': 'Please enter incremental step',
  'jeepneyActivity.randomDistributionFormulaGeneration': 'Generate Random Distribution Formula',
  'jeepneyActivity.rewardProgressionPerStage': 'Reward Progression per Stage',
  'jeepneyActivity.stagesPerIncrease': 'Every N Stages',
  'jeepneyActivity.stagesPerIncreaseRequired': 'Please enter every N stages',
  'jeepneyActivity.stagesPerIncreaseMin': 'Must be greater than 0',
  'jeepneyActivity.minValueIncrease': 'Min Value Increase',
  'jeepneyActivity.minValueIncreaseRequired': 'Please enter min value increase',
  'jeepneyActivity.maxValueIncrease': 'Max Value Increase',
  'jeepneyActivity.maxValueIncreaseRequired': 'Please enter max value increase',
  'jeepneyActivity.rewardProgressionHint': 'Suggestion: The minimum value should not exceed the maximum value; the wider the range, the stronger the sense of randomness.',
  'jeepneyActivity.tailStageMultiplierValue': 'Tail Stage Multiplier Value',
  'jeepneyActivity.tailStageMultiplier': 'Tail Stage Multiplier',
  'jeepneyActivity.sectionEndMultiplier': 'Section End Multiplier',
  'jeepneyActivity.tailRewardMultiplier': 'Tail Reward x',
  'jeepneyActivity.tailStageMultiplierDesc': 'Tail stages multiply the reward content by the set value',
  'jeepneyActivity.tailStageMultiplierTip': 'Tail stages multiply the reward content by the set value',
  'jeepneyActivity.sectionEndMultiplierTip': 'Tail stages multiply the reward content by the set value',
  'jeepneyActivity.finalStageMultiplierValue': 'Final Stage Multiplier Value',
  'jeepneyActivity.finalMultiplier': 'Final Multiplier',
  'jeepneyActivity.finalStageMultiplier': 'Final Stage Multiplier',
  'jeepneyActivity.finalRewardMultiplier': 'Final Reward x',
  'jeepneyActivity.finalStageMultiplierDesc': 'The final stage multiplies the reward content by the set value',
  'jeepneyActivity.sectionEndMultiplierTip': 'Tail stages multiply the reward content by the set value',
  'jeepneyActivity.finalMultiplierTip': 'The final stage multiplies the reward content by the set value',
  'jeepneyActivity.safetyUpperLimit': 'Safety Upper Limit (Max value not exceeded)',
  'jeepneyActivity.safetyUpperLimitRequired': 'Please enter safety upper limit',
  'jeepneyActivity.safetyUpperLimitDesc': 'Explanation: The generated result will be limited to not exceed the upper limit. Enter 0 to disable the upper limit.',
  'jeepneyActivity.safetyCap': 'Safety Upper Limit (Max value not exceeded)',
  'jeepneyActivity.safetyCapTip': 'Explanation: The generated result will be limited to not exceed the upper limit. Enter 0 to disable the upper limit.',
  'jeepneyActivity.previewAutoRefresh': 'Preview (Auto Refresh)',
  'jeepneyActivity.currentStage': 'Current Stage',
  'jeepneyActivity.stage': 'Stage',
  'jeepneyActivity.stageType': 'Stage Type',
  'jeepneyActivity.autoGenerate': 'Auto Generate',
  'jeepneyActivity.autoGenerateFixed': 'Auto Generate (Fixed)',
  'jeepneyActivity.autoGenerateRandom': 'Auto Generate (Random)',
  'jeepneyActivity.manualGenerate': 'Manual Generate',
  'jeepneyActivity.randomReward': 'Random Reward: Value is randomly generated within the range',
  'jeepneyActivity.rewardColorTip.fixed': 'Fixed reward with constant value',
  'jeepneyActivity.rewardColorTip.random': 'Random reward with value randomly generated within the range',
  'jeepneyActivity.actualConsumptionNegativeWarning': 'Actual consumption is negative, which is considered abnormal except for the final stage and will block saving',
  'jeepneyActivity.stageType.normal': 'Normal',
  'jeepneyActivity.stageType.tail': 'Tail Stage',
  'jeepneyActivity.stageType.final': 'Final Stage',
  'jeepneyActivity.result': 'Result (Corresponding Reward)',
  'jeepneyActivity.minValueExceedsMax': 'Minimum value should not exceed maximum value',
  'jeepneyActivity.multiplierLessThanOne': 'Magnification cannot be less than 1',
  'jeepneyActivity.multiplierMin': 'Must be greater than or equal to 1',
  'jeepneyActivity.abnormalStatusMessage': 'Abnormal status: When the minimum value is greater than the maximum value, or the growth rhythm is 0, or the magnification is less than 1, saving will be blocked and a prompt will be displayed during verification.',
  'jeepneyActivity.finalStageConsumptionTooltip': 'Default actual consumption = Current level accumulated threshold - Previous level accumulated threshold (Level 1 subtracts 0)\n•Levels 1~N: Accumulated threshold must strictly increase\n•Final Level N: Accumulated threshold must be ≥ previous level (equal allowed = final level difference is 0)\n•Any level difference consumption cannot be negative (system calculation)\n•Manual modification of a single level, or final level actual consumption, is not affected by default configuration.\nNote: Clicking the push button on the client side will definitely advance 1 level. To avoid no movement after clicking, if not configured, the game cannot be played.',
  'jeepneyActivity.finalStageConsumptionRequired': 'Please enter final stage consumption',
  'jeepneyActivity.distributionMethodRequired': 'Please select distribution method',
  'jeepneyActivity.turnoverMultiple': 'Turnover',
  'jeepneyActivity.turnoverMultipleRequired': 'Please enter turnover multiple',
  'jeepneyActivity.times': 'times',
  'jeepneyActivity.vipLevel': 'VIP Level',
  'jeepneyActivity.allowedCashOutStages': 'Allowed Cash Out Stages',
  'jeepneyActivity.rewardSyncStrategy': 'Reward Sync Strategy',
  'jeepneyActivity.rewardSyncStrategyRequired': 'Please select reward sync strategy',
  'jeepneyActivity.rewardSyncStrategy.coverAll': 'Cover All Stages',
  'jeepneyActivity.rewardSyncStrategy.merge': 'Merge Rewards',
  'jeepneyActivity.configMethod': 'Configuration Method',
  'jeepneyActivity.configMethodRequired': 'Please select configuration method',
  'jeepneyActivity.configMethod.autoGenerate': 'Auto Generate',
  'jeepneyActivity.configMethod.manual': 'Manual',
  'jeepneyActivity.firstStageValue': 'Value',
  'jeepneyActivity.firstStageValueRequired': 'Please enter value',
  'jeepneyActivity.firstStageMinValueRequired': 'Please enter min value',
  'jeepneyActivity.firstStageMaxValueRequired': 'Please enter max value',
  'jeepneyActivity.rewardConfigTip': 'Each stage configuration recommends actual calculation, manual verification',
  'jeepneyActivity.useDefaultConfig': 'Use Default Config',
  'jeepneyActivity.stageRewardConfig': 'Single Stage Reward Configuration',
  'jeepneyActivity.generationRule': 'Generation Rule',
  'jeepneyActivity.generateRandomRule': 'Generate Random Rule',
  'jeepneyActivity.generateFixedRule': 'Generate Fixed Rule',
  'jeepneyActivity.fixedDistributionFormulaGeneration': 'Fixed Distribution Formula Generation',
  'jeepneyActivity.fixedIncrease': 'Fixed Increase',
  'jeepneyActivity.fixedIncreaseRequired': 'Please enter fixed increase',
  'jeepneyActivity.fixedIncreasePerPeriod': 'Fixed value increased per period',
  'jeepneyActivity.growthPeriod': 'Growth Period',
  'jeepneyActivity.roundingMethod': 'Rounding Method',
  'jeepneyActivity.roundingMethodRequired': 'Please select rounding method',
  'jeepneyActivity.roundingMethod.round': 'Round to nearest',
  'jeepneyActivity.roundingMethod.ceil': 'Round up',
  'jeepneyActivity.roundingMethod.floor': 'Round down',
  'jeepneyActivity.actualConsumptionStrategy': 'Actual Consumption Strategy',
  'jeepneyActivity.consumptionStrategy.fixed': 'Fixed',
  'jeepneyActivity.consumptionStrategy.incremental': 'Incremental',
  'jeepneyActivity.inheritDefaultConsumption': 'Inherit Default Consumption',
  'jeepneyActivity.finalStageConsumptionEditTip': 'Will not affect other stages, only modify actual consumption',
  'jeepneyActivity.settlementSettings': 'Settlement Settings',
  'jeepneyActivity.settlementThreshold': 'Settlement Threshold',
  'jeepneyActivity.settlementThresholdTypeRequired': 'Please select settlement threshold type',
  'jeepneyActivity.completeFinalStage': 'Complete Final Stage',
  'jeepneyActivity.occurredInRound': 'At least happened in this round',
  'jeepneyActivity.inviteValidUsers': 'Invite Valid Users ≥',
  'jeepneyActivity.inviteValidUsersRequired': 'Please enter invite valid users',
  'jeepneyActivity.weightCalculation': 'Weight Calculation',
  'jeepneyActivity.rechargeWeight': 'Recharge Weight per Time',
  'jeepneyActivity.rechargeWeightRequired': 'Please enter recharge weight per time',
  'jeepneyActivity.inviteWeight': 'Invite Weight per Person',
  'jeepneyActivity.inviteWeightRequired': 'Please enter invite weight per person',
  'jeepneyActivity.dynamicProbability': 'Dynamic Probability',
  'jeepneyActivity.round': 'Round',
  'jeepneyActivity.baseProbability': 'Base Probability(%)',
  'jeepneyActivity.baseProbabilityRequired': 'Please enter base probability',
  'jeepneyActivity.weightConversionFactor': 'Weight Conversion Factor',
  'jeepneyActivity.weightConversionFactorRequired': 'Please enter weight conversion factor',
  'jeepneyActivity.failureIncreasePerTime': 'Failure Increase per Time(%)',
  'jeepneyActivity.failureIncreasePerTimeRequired': 'Please enter failure increase per time',
  'jeepneyActivity.failureIncreaseCap': 'Failure Increase Cap(%)',
  'jeepneyActivity.failureIncreaseCapRequired': 'Please enter failure increase cap',
  'jeepneyActivity.minProbability': 'Min Probability(%)',
  'jeepneyActivity.minProbabilityRequired': 'Please enter min probability',
  'jeepneyActivity.maxProbability': 'Max Probability(%)',
  'jeepneyActivity.maxProbabilityRequired': 'Please enter max probability',
  'jeepneyActivity.actualProbability': 'Actual Probability',
  'jeepneyActivity.noDynamicProbabilityRounds': 'No dynamic probability configuration yet, please click "Add New" to add',
  'jeepneyActivity.roundExplanation': 'Only after completing the final stage (Stage N), the round increases by 1; intermediate cash-outs are not counted as rounds.',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.edit': 'Edit',
  'common.apply': 'Apply',
  'common.on': 'On',
  'common.off': 'Off',
  'common.allow': 'Allow',
  'common.disallow': 'Disallow',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.add': 'Add',
  'jeepneyActivity.settlementFailureSettings': 'Settlement Failure Settings',
  'jeepneyActivity.settlementFailureTaskSettings': 'Settlement Failure Task Settings',
  'jeepneyActivity.settlementFailureTaskRuleTip': 'When configuring operations, ensure that the failure count tiers are clear to avoid confusion caused by multiple configurations for the same failure count.',
  'jeepneyActivity.failureCount': 'Failure Count',
  'jeepneyActivity.failureCountRequired': 'Please select failure count',
  'jeepneyActivity.inviteValidFriendsRequired': 'Please enter number of valid invite friends',
  'jeepneyActivity.noRechargeTasks': 'No recharge task configuration yet, please click "Add New" to add',
  'jeepneyActivity.noInviteTasks': 'No invite task configuration yet, please click "Add New" to add',

  // ===== Jeepney 多币种改版新增 =====
  'jeepneyActivity.addCurrency': 'Currency',
  'jeepneyActivity.currencyPending': 'To fill',
  'jeepneyActivity.removeCurrencyGroup': 'Remove this currency',
  'jeepneyActivity.keepAtLeastOneCurrency': 'Keep at least one currency',
  'jeepneyActivity.currencyHint': 'Selected currencies get their own required inputs in every amount row; keep at least one',
  'jeepneyActivity.removeCurrencyConfirm': 'Removing this currency clears all amounts already entered for it, and its players will no longer see this event. Continue?',
  'jeepneyActivity.confirmRemoveCurrency': 'Remove',
  'jeepneyActivity.thinkAgain': 'Cancel',
  'jeepneyActivity.cashRowOnlyOne': 'Only one cash row is allowed',
  'jeepneyActivity.currencyGroupIncomplete': 'Please complete the settings for every currency',
  'jeepneyActivity.allCurrenciesShared': 'Shared across currencies',
  'jeepneyActivity.currencyConfigRecharge': 'Deposit ≥ (per currency)',
  'jeepneyActivity.currencyConfigFriends': 'Valid friends (per currency)',
  'jeepneyActivity.currencyConfigRechargeTime': 'Per currency (deposit ≥ + time added)',
  'jeepneyActivity.currencyConfigFriendsTime': 'Per currency (valid friends + time added)',
  'jeepneyActivity.currencyConfigRechargeFuel': 'Per currency (deposit ≥ + fuel granted)',
  'jeepneyActivity.rechargeGte': 'Deposit ≥',
  'jeepneyActivity.addTime': 'Time +',
  'jeepneyActivity.fuel': 'Fuel',
  'jeepneyActivity.friends': 'Friends',
  'jeepneyFunnelAnalysis.currency': 'Currency',
  'jeepneyFunnelAnalysis.currencyAll': 'All',
  'jeepneyUserList.crossCurrencyNoSum': 'Amounts are not summed across currencies. Filter by a single currency to see total cost and return rate.',
  'jeepneyActivity.selectCurrencyFirst': 'Select currencies in Basic Settings first',
  'jeepneyActivity.allCurrenciesAdded': 'All selected currencies have been added',
  'jeepneyActivity.minAmount': 'Amount ≥',
  'jeepneyFunnelAnalysis.statisticsDate': 'Statistics date',
  'jeepneyFunnelAnalysis.dateSelect': 'Select date',
  'jeepneyFunnelAnalysis.fixedForToday': 'Fixed through today',
  // Bet Milestone (Daily / Weekly)
  'chickActivity.dailyBetMilestone': 'Bet Milestone (Daily)',
  'chickActivity.weeklyBetMilestone': 'Bet Milestone (Weekly)',
  'chickActivity.dailyBetMilestoneDesc': 'Rewards are written to the treasure box on completion and must be claimed manually. No independent 24h countdown; a new task starts at 00:00 the next day, and the previous day\'s unclaimed rewards are voided automatically. No stamina requirement; stamina = 0 (Sick) can also participate.',
  'chickActivity.weeklyBetMilestoneDesc': 'Rewards are written to the treasure box on completion and must be claimed manually. No independent 24h countdown; a new weekly task starts at 00:00 next Monday, and last week\'s unclaimed rewards are voided automatically. No stamina requirement.',
  'chickActivity.dailyTemplateHint': ' — {amount}/{reward} auto-fill each row\'s threshold and reward; the whole table shares one template.',
  'chickActivity.weeklyTemplateHint': ' — {amount}/{reward} auto-fill each row\'s threshold and reward; the whole table shares one template.',
  'chickActivity.newBadge': 'New',
  'chickActivity.copyPreview': 'Copy Preview (auto)',
  'chickActivity.autoGenReadonly': 'Auto-generated, read-only',
  'chickActivity.milestoneCondition': 'Condition',
  'chickActivity.currencyThreshold': 'Multi-currency Threshold',
  'chickActivity.rewardValue': 'Reward Value',
  'chickActivity.turnoverMultiple': 'Turnover Multiple',
  'chickActivity.copyTemplateMultiLang': 'Copy Template (Multi-language)',
  'chickActivity.templatePlaceholderHint': 'Placeholders: {amount} (threshold), {reward} (reward value). The whole table shares one template.',
  'chickActivity.globalCurrencySettings': 'Global Multi-currency Settings',
  'chickActivity.globalRateHint': 'Set the converted value of 1 {base} for each currency; tiers set to "Use Global" convert the threshold accordingly.',
  'chickActivity.ratePerBase': '1 {base} =',
  'chickActivity.baseCurrencyHint': 'Each tier is configured based on {base}; other currencies convert by the global settings above by default, and each tier can override.',
  'chickActivity.currencyThresholdSettings': 'Multi-currency Threshold Settings',
  'chickActivity.currencyThresholdModalDesc': 'Leave blank to use global conversion for that currency; fill in to use a custom threshold for this tier.',
  'chickActivity.threshold': 'Threshold',
  'chickActivity.resetToGlobal': 'Reset to Use Global',
  'chickActivity.addTierSlot': 'Add Tier',
  'chickActivity.notConfigured': 'Not configured',
  'chickActivity.selectCurrency': 'Select currency',
  'chickActivity.milestoneCurrencyHint': 'Each currency has its own tiers; switch the currency above to edit that currency\'s tiers. Currencies are independent of each other.',
  'chickActivity.milestoneRuleEnergy': 'Bet milestones have no stamina requirement; any stamina level (including 0 / Sick) can accumulate and claim.',
  'chickActivity.milestoneRuleClaim': 'On completion, bet milestone rewards are written to the treasure box and must be claimed manually; no independent 24h countdown — when a new round starts at 00:00 daily / 00:00 Monday weekly, the previous round\'s achieved-but-unclaimed rewards are voided automatically.',

  // Common - Weekdays
  'common.weekday.monday': 'Monday',
  'common.weekday.tuesday': 'Tuesday',
  'common.weekday.wednesday': 'Wednesday',
  'common.weekday.thursday': 'Thursday',
  'common.weekday.friday': 'Friday',
  'common.weekday.saturday': 'Saturday',
  'common.weekday.sunday': 'Sunday',

  // Red Packet Activity
  'redPacket.title': 'Red Packet Settings',
  'redPacket.name': 'Red Packet Name',
  'redPacket.enterName': 'Please enter red packet name',
  'redPacket.ruleTitle': 'Rule Title',
  'redPacket.enterRuleTitle': 'Please enter rule title',
  'redPacket.ruleContent': 'Rule Description',
  'redPacket.enterRuleContent': 'Please enter rule description',
  'redPacket.currency': 'Currency',
  'redPacket.selectCurrency': 'Please select currency',
  'redPacket.addRedPacket': 'Add Red Packet',
  'redPacket.editRedPacket': 'Edit Red Packet',
  'redPacket.createSuccess': 'Created successfully',
  'redPacket.updateSuccess': 'Updated successfully',
  'redPacket.hasIssueRecordsTip': 'This activity has existing issue records. User type, statistics period, event types, distribution type, distribution method, and red packet amount range cannot be changed. Only name, distribution time, and claim validity can be edited.',
  'redPacket.deleteSuccess': 'Deleted successfully',
  'redPacket.confirmDelete': 'Are you sure you want to delete this red packet activity?',
  'redPacket.dataLoadFailed': 'Failed to load data',
  'redPacket.operation': 'Operation',

  'redPacket.stats.title': 'Red Packet Rain Statistics',
  'redPacket.stats.redPacketName': 'Red Packet Name',
  'redPacket.stats.distributionTime': 'Distribution Time',
  'redPacket.stats.distributionMethod': 'Distribution Method',
  'redPacket.stats.userCount': 'Distributed Users',
  'redPacket.stats.totalAmount': 'Actual Amount',
  'redPacket.stats.settings': 'Settings',
  'redPacket.stats.viewMemberList': 'View List',
  'redPacket.stats.memberAccount': 'Member Account',
  'redPacket.stats.amount': 'Amount',
  'redPacket.stats.claimTime': 'Claim Time',
  'redPacket.stats.exportMemberList': 'Export List',
  'redPacket.stats.loadFailed': 'Failed to load',
  'redPacket.stats.memberListLoadFailed': 'Failed to load member list',

  'redPacket.distributionType.label': 'Distribution Type',
  'redPacket.distributionType.daily': 'Daily',
  'redPacket.distributionType.weekly': 'Weekly',
  'redPacket.distributionType.monthly': 'Monthly',
  'redPacket.distributionType.specified': 'Specified',
  'redPacket.selectDistributionType': 'Please select distribution type',

  'redPacket.distributionTime': 'Distribution Time',
  'redPacket.selectDistributionTime': 'Please select distribution time',
  'redPacket.weekDay': 'Weekday',
  'redPacket.selectWeekDay': 'Please select weekday',
  'redPacket.monthDay': 'Day',
  'redPacket.selectMonthDay': 'Please select day',
  'redPacket.time': 'Time',
  'redPacket.selectTime': 'Please select time',

  'redPacket.distributionMethod.label': 'Distribution Method',
  'redPacket.distributionMethod.scheduled': 'Scheduled Claim',
  'redPacket.distributionMethod.popup': 'Popup Claim',
  'redPacket.distributionMethod.autoCredit': 'Auto Credit',
  'redPacket.selectDistributionMethod': 'Please select distribution method',

  'redPacket.claimValidity': 'Claim Validity',
  'redPacket.enterValidityValue': 'Please enter validity value',
  'redPacket.selectValidityUnit': 'Please select unit',
  'redPacket.validityUnit.minute': 'Minute(s)',
  'redPacket.validityUnit.day': 'Day(s)',

  'redPacket.amountRange': 'Red Packet Amount Range',
  'redPacket.amountConfig': 'Amount Configuration',
  'redPacket.minAmount': 'Min Amount',
  'redPacket.enterMinAmount': 'Please enter min amount',
  'redPacket.maxAmount': 'Max Amount',
  'redPacket.enterMaxAmount': 'Please enter max amount',

  'redPacket.userType.label': 'User Type',
  'redPacket.userType.nonFirstDeposit': 'Non-First Deposit',
  'redPacket.userType.nonfirstdeposit': 'Non-First Deposit',
  'redPacket.userType.firstDeposit': 'First Deposit',
  'redPacket.userType.firstdeposit': 'First Deposit',
  'redPacket.userType.specifiedUser': 'Specified User',
  'redPacket.userType.specifieduser': 'Specified User',
  'redPacket.selectUserType': 'Please select user type',
  'redPacket.userConfig': 'User Configuration',

  'redPacket.uploadMemberList': 'Upload List',
  'redPacket.uploadMemberListTip': 'Please upload CSV file, format: first row header is memberAccount, each row contains one account',
  'redPacket.memberListRequired': 'Please upload member list',
  'redPacket.memberCount': '{count} members',
  'redPacket.specifiedUsers': 'Specified Users',

  'redPacket.statisticsTime': 'Statistics Time',
  'redPacket.statisticsConfig': 'Statistics Configuration',
  'redPacket.statisticsCycle.label': 'Statistics Cycle',
  'redPacket.statisticsCycle.weekly': 'Weekly',
  'redPacket.statisticsCycle.monthly': 'Monthly',
  'redPacket.selectStatisticsCycle': 'Please select statistics cycle',
  'redPacket.userTypeStatisticsCycle.label': 'User Type Statistics Cycle',
  'redPacket.statisticsStartDay': 'Start Day',
  'redPacket.selectStartDay': 'Please select start day',
  'redPacket.statisticsEndDay': 'End Day',
  'redPacket.selectEndDay': 'Please select end day',
  'redPacket.statisticsEffectiveTime.label': 'Statistics Effective Time',
  'redPacket.turnoverMultiple.label': 'Turnover Multiple',
  'redPacket.turnoverMultiple.placeholder': 'Enter turnover multiple',
  'redPacket.turnoverMultiple.required': 'Please enter turnover multiple',
  'redPacket.statisticsEffectiveTime.placeholder': 'Select statistics effective time',
  'redPacket.statisticsEffectiveTime.tooltip': 'Only data after this time will be counted, preventing historical data from being included',
  'redPacket.statisticsRange': 'Statistics Range',

  'redPacket.cycleMismatchWeekly': 'For weekly statistics, distribution can only be Daily or Weekly',
  'redPacket.cycleMismatchMonthly': 'For monthly statistics, distribution can only be Monthly or Specified',

  'redPacket.eventType.label': 'Event Type',
  'redPacket.eventType.deposit': 'Deposit',
  'redPacket.eventType.bet': 'Bet',
  'redPacket.eventType.negativeProfit': 'Negative Profit',
  'redPacket.eventType.negativeprofit': 'Negative Profit',
  'redPacket.eventType.negative_profit': 'Negative Profit',
  'redPacket.eventType.balance': 'Balance',
  'redPacket.selectEventType': 'Please select event type',
  'redPacket.addEventType': 'Add Event Type',
  'redPacket.eventTypeConfig': 'Event Type Configuration',
  'redPacket.eventTypeRequired': 'Please add at least one event type',

  // FBMPLAY-1737 阶梯配置
  'redPacket.tier.section': 'Tier Configuration',
  'redPacket.tier.title': 'Tier',
  'redPacket.tier.add': 'Add Tier',
  'redPacket.tier.remove': 'Remove Tier',
  'redPacket.tier.conditionMin': 'Condition Min Amount',
  'redPacket.tier.conditionMax': 'Condition Max Amount',
  'redPacket.tier.noLimitPlaceholder': 'Leave blank for no upper limit',
  'redPacket.tier.noLimit': 'No limit',
  'redPacket.tier.rewardMin': 'Reward Min Amount',
  'redPacket.tier.rewardMax': 'Reward Max Amount',
  'redPacket.tier.required': 'Please set at least one tier',
  'redPacket.tier.conditionMinRequired': 'Please enter condition min amount',
  'redPacket.tier.conditionMaxRequired': 'Please enter condition max amount (only the last tier may be blank)',
  'redPacket.tier.conditionRangeInvalid': 'Condition min amount cannot exceed condition max amount',
  'redPacket.tier.rewardRequired': 'Please enter reward min/max amount',
  'redPacket.tier.rewardRangeInvalid': 'Reward min amount cannot exceed reward max amount',
  'redPacket.tier.multipleRequired': 'Please enter turnover multiple',
  'redPacket.tier.overlap': 'Condition min amount must be greater than the max amount of the previous tier (tiers must ascend without overlap)',
  'redPacket.tier.hint': 'Event type is shared by all tiers; tier condition ranges must ascend without overlap, blank max on the last tier means no upper limit; users receive the highest qualified tier',
  'redPacket.tier.legacyHint': 'This activity uses the legacy configuration (multiple events / fixed amount) and is no longer evaluated after the upgrade; please set the event type and tiers before saving',
  'redPacket.tier.legacyTag': 'Legacy',

  'redPacket.distributionConfig': 'Distribution Configuration',

  // Treasure Box
  'treasureBox.config.title': 'Treasure Box Settings',
  'treasureBox.config.activityStatus': 'Activity Status',
  'treasureBox.config.enabled': 'Enabled',
  'treasureBox.config.disabled': 'Disabled',
  'treasureBox.config.activityThreshold': 'Activity Threshold',
  'treasureBox.config.activityThresholdDesc': 'After midnight daily, randomly distribute boxes to users with chick check-in activity >= this value',
  'treasureBox.config.dailyBoxLimit': 'Daily Box Limit',
  'treasureBox.config.dailyBoxLimitDesc': 'Maximum number of boxes distributed per 24 hours',
  'treasureBox.config.levelConfig': 'Box Level Configuration',
  'treasureBox.config.levelName': 'Level Name',
  'treasureBox.config.dropRate': 'Drop Rate (%)',
  'treasureBox.config.expireHours': 'Expire Hours',
  'treasureBox.config.prizeConfig': 'Prize Config (Bonus)',
  'treasureBox.config.flowMultiple': 'Flow Multiple',
  'treasureBox.config.setup': 'Setup',
  'treasureBox.config.save': 'Save',
  'treasureBox.config.saveSuccess': 'Save successful',
  'treasureBox.config.saveFailed': 'Save failed',
  'treasureBox.config.loadFailed': 'Failed to load config',
  'treasureBox.config.dropRateSumError': 'All level drop rates must sum to 100%, currently {total}%',
  'treasureBox.config.enableGuard': 'Before enabling: drop rates must sum to 100%, and every level with a drop rate > 0 must have prize ranges configured',
  'treasureBox.config.statusUpdateSuccess': 'Status updated successfully',
  'treasureBox.config.statusUpdateFailed': 'Status update failed',
  'treasureBox.config.prizeConfigTitle': 'Prize Configuration',
  'treasureBox.config.minAmount': 'Min Amount',
  'treasureBox.config.maxAmount': 'Max Amount',
  'treasureBox.config.probability': 'Probability (%)',
  'treasureBox.config.addRange': 'Add Range',
  'treasureBox.config.prizeProbSumError': 'All prize range probabilities must sum to 100%, currently {total}%',
  'treasureBox.config.currentPrize': 'Current Prize Ranges',

  'treasureBox.level.WOOD': 'Wooden Chest',
  'treasureBox.level.IRON': 'Iron Chest',
  'treasureBox.level.BRONZE': 'Bronze Chest',
  'treasureBox.level.SILVER': 'Silver Chest',
  'treasureBox.level.GOLD': 'Gold Chest',
  'treasureBox.level.DIAMOND': 'Diamond Chest',

  'treasureBox.stats.title': 'Box Statistics',
  'treasureBox.stats.dateRange': 'Date Range',
  'treasureBox.stats.search': 'Search',
  'treasureBox.stats.reset': 'Reset',
  'treasureBox.stats.levelName': 'Level Name',
  'treasureBox.stats.statsDate': 'Date',
  'treasureBox.stats.coinCode': 'Currency',
  'treasureBox.records.coinCode': 'Currency',
  'treasureBox.stats.grantCount': 'Granted',
  'treasureBox.stats.openCount': 'Opened',
  'treasureBox.stats.expiredCount': 'Expired',
  'treasureBox.stats.totalPrizeAmount': 'Total Prize Amount',
  'treasureBox.stats.keyGrantCount': 'Keys Granted',
  'treasureBox.stats.keyUsedCount': 'Keys Used',
  'treasureBox.stats.timeRequired': 'Please select a date range',
  'treasureBox.stats.queryFailed': 'Failed to query statistics',

  'treasureBox.records.title': 'Box Distribution Records',
  'treasureBox.records.boxId': 'Box ID',
  'treasureBox.records.memberAccount': 'Member Account',
  'treasureBox.records.memberInfoId': 'User ID',
  'treasureBox.records.keyId': 'Key ID',
  'treasureBox.records.levelCode': 'Box Level',
  'treasureBox.records.grantTime': 'Grant Time',
  'treasureBox.records.expireTime': 'Expire Time',
  'treasureBox.records.openTime': 'Open Time',
  'treasureBox.records.openKeyId': 'Open Key ID',
  'treasureBox.records.prizeAmount': 'Prize Amount',
  'treasureBox.records.flowMultiple': 'Flow Multiple',
  'treasureBox.records.tradeNo': 'Trade No',
  'treasureBox.records.search': 'Search',
  'treasureBox.records.reset': 'Reset',
  'treasureBox.records.queryFailed': 'Failed to query records',
  'treasureBox.records.selectLevel': 'Select box level',
  'treasureBox.records.allLevels': 'All Levels',
  'treasureBox.records.boxStatus': 'Box Status',
  'treasureBox.records.boxStatus.pending': 'Pending',
  'treasureBox.records.boxStatus.opened': 'Opened',
  'treasureBox.records.boxStatus.expired': 'Expired',
  'treasureBox.records.grantSource': 'Grant Source',
  'treasureBox.records.grantSource.autoGrant': 'Daily Auto Grant',
  'treasureBox.records.grantSource.activityReward': 'Activity Reward',
  'treasureBox.records.selectBoxStatus': 'Select box status',
  'treasureBox.records.selectGrantSource': 'Select grant source',
  'treasureBox.records.timeRequired': 'Please select at least one time range',
  'treasureBox.records.keyDataPkCode': 'Open Key Code',


  // ========== Free Spin Grant ==========

  // Whitelist

  // Grant

  // Grant list & search

  // Batch

  // Batch status

  // Detail

  // Detail status

  // Stats

  // ===== Vendor Leaderboard =====
  'activity.vendorLeaderboard.title': 'Vendor Leaderboard',
  'activity.vendorLeaderboard.boardConfigTitle': 'B · Board Config',
  'activity.vendorLeaderboard.boardConfigTip': 'Each board is independent: game scope / members / ranking metric / rewards / distribution. Switch boards above to configure separately.',
  'activity.vendorLeaderboard.addBoard': 'Add Board',
  'activity.vendorLeaderboard.board': 'Board',
  'activity.vendorLeaderboard.overallBoard': 'Daily Overall',
  'activity.vendorLeaderboard.unnamedBoard': 'Unnamed Board',
  'activity.vendorLeaderboard.confirmRemoveBoard': 'Remove this board?',
  'activity.vendorLeaderboard.boardBasic': 'Board Basics',
  'activity.vendorLeaderboard.boardNameZh': 'Board Name (ZH)',
  'activity.vendorLeaderboard.boardNameZhTip': 'Front-end tab name in Chinese',
  'activity.vendorLeaderboard.boardNameEn': 'Board Name (EN)',
  'activity.vendorLeaderboard.boardNameEnTip': 'Front-end tab name in English',
  'activity.vendorLeaderboard.boardSort': 'Display Order (front-end tab order)',
  'activity.vendorLeaderboard.boardSortTip': 'Smaller value shows first',
  'activity.vendorLeaderboard.boardBanner': 'Board Banner (front-end, per board)',
  'activity.vendorLeaderboard.boardBannerTip': 'Upload a banner for each platform',
  'activity.vendorLeaderboard.bannerH5': 'H5 Banner',
  'activity.vendorLeaderboard.bannerPc': 'PC Banner',
  'activity.vendorLeaderboard.bannerApp': 'App Banner',
  'activity.vendorLeaderboard.gameScope': 'Board Scope',
  'activity.vendorLeaderboard.gameScopeTip': 'Select which games count for this board: Category / Platform / Game (3 levels). A half-checked parent means partial selection. 6 fixed categories; Sports only to platform level.',
  'activity.vendorLeaderboard.searchGame': 'Search game',
  'activity.vendorLeaderboard.catSlot': 'Slot',
  'activity.vendorLeaderboard.catCasino': 'Casino',
  'activity.vendorLeaderboard.catPoker': 'Poker',
  'activity.vendorLeaderboard.catBingo': 'Bingo',
  'activity.vendorLeaderboard.catSports': 'Sports',
  'activity.vendorLeaderboard.catFish': 'Fish',
  'activity.vendorLeaderboard.memberScope': 'Participating Members',
  'activity.vendorLeaderboard.joinMember': 'Members',
  'activity.vendorLeaderboard.memberAll': 'All Members',
  'activity.vendorLeaderboard.memberVip': 'Specified VIP Levels',
  'activity.vendorLeaderboard.vipLevels': 'VIP Levels',
  'activity.vendorLeaderboard.rankSource': 'Ranking Metric & Data Source',
  'activity.vendorLeaderboard.metric': 'Ranking Metric',
  'activity.vendorLeaderboard.metricValidBet': 'Valid Bet (Bet Board)',
  'activity.vendorLeaderboard.metricProfit': 'Profit (Win Board)',
  'activity.vendorLeaderboard.metricLoss': 'Loss (Loss Board)',
  'activity.vendorLeaderboard.rankSourceTip': 'Data source reuses the User Ranking boards (bet / win / loss), period includes real-time (current) + yesterday (last fixed board), counted by natural cycle (non-rolling). The front-end value column follows the metric: valid bet / profit / loss. Invalid bets, hedging, and matched bets are judged by platform risk control and the data layer.',
  'activity.vendorLeaderboard.minThreshold': 'Min Board Threshold (PHP)',
  'activity.vendorLeaderboard.minThresholdTip': 'Valid bet below this does not enter the board',
  'activity.vendorLeaderboard.minBoardCount': 'Min Board Players',
  'activity.vendorLeaderboard.minBoardCountTip': 'When insufficient, empty ranks are not paid to prevent low-traffic arbitrage',
  'activity.vendorLeaderboard.optional': 'Optional',
  'activity.vendorLeaderboard.rewardLadder': 'Reward Ladder',
  'activity.vendorLeaderboard.importExcel': 'Upload Excel',
  'activity.vendorLeaderboard.downloadTemplate': 'Download Template',
  'activity.vendorLeaderboard.importTip': 'Template fields: Rank (or range start · end) · Count · Reward Type (Cash / Points / Spin Ticket) · Reward Value · Flow Multiple (for cash) · Spin Type (for ticket). Import overwrites the current ladder.',
  'activity.vendorLeaderboard.importEmpty': 'No valid data parsed',
  'activity.vendorLeaderboard.importSuccess': 'Imported {{count}} tiers',
  'activity.vendorLeaderboard.importFail': 'Import failed, please check the file format',
  'activity.vendorLeaderboard.enableRankRange': 'Enable Rank Range',
  'activity.vendorLeaderboard.enableRankRangeTip': 'By default each rank is configured separately; once enabled, you can batch-assign the same reward to a range (e.g. 4~10)',
  'activity.vendorLeaderboard.rank': 'Rank',
  'activity.vendorLeaderboard.count': 'Count',
  'activity.vendorLeaderboard.rewardContent': 'Rewards (multiple)',
  'activity.vendorLeaderboard.rewardValue': 'Value',
  'activity.vendorLeaderboard.rewardCash': 'Cash',
  'activity.vendorLeaderboard.rewardPoint': 'Points',
  'activity.vendorLeaderboard.rewardSpinTicket': 'Spin Ticket',
  'activity.vendorLeaderboard.flowLabel': 'Flow',
  'activity.vendorLeaderboard.times': 'x',
  'activity.vendorLeaderboard.selectSpinType': 'Select spin type',
  'activity.vendorLeaderboard.addReward': 'Add Reward',
  'activity.vendorLeaderboard.addRank': 'Add Rank',
  'activity.vendorLeaderboard.operation': 'Action',
  'activity.vendorLeaderboard.delete': 'Delete',
  'activity.vendorLeaderboard.settlement': 'Settlement & Distribution',
  'activity.vendorLeaderboard.settleCycle': 'Settlement Cycle (days)',
  'activity.vendorLeaderboard.settleCycleTip': 'Number of days counted from the board active start (not tied to a natural week); settled and reset every N days',
  'activity.vendorLeaderboard.days': 'days',
  'activity.vendorLeaderboard.boardTime': 'Board Active Time',
  'activity.vendorLeaderboard.boardTimeTip': 'Start / end time of this board; must fall within the activity active time range',
  'activity.vendorLeaderboard.errBoardTimeRequired': 'Please set the active time for board "{{name}}"',
  'activity.vendorLeaderboard.errBoardTimeOrder': 'Board "{{name}}" start time must be earlier than end time',
  'activity.vendorLeaderboard.errBoardTimeWithinActivity': 'Board "{{name}}" active time must be within the activity active time range',
  'activity.vendorLeaderboard.errSettleCycle': 'Board "{{name}}" settlement cycle must be a number of days greater than 0',
  'activity.vendorLeaderboard.tieRule': 'Tie Rule',
  'activity.vendorLeaderboard.tieFirstReach': 'First to reach wins',
  'activity.vendorLeaderboard.arrivalTiming': 'Arrival Timing',
  'activity.vendorLeaderboard.arrivalTimingFixed': 'Next day 16:00',
  'activity.vendorLeaderboard.arrivalTimingTip': 'Paid before 16:00 the next day after the board is fixed (system-fixed)',
  'activity.vendorLeaderboard.distributeMode': 'Distribution',
  'activity.vendorLeaderboard.distributeDirect': 'Direct to user account',
  'activity.vendorLeaderboard.distributeClaim': 'User must claim',
  'activity.vendorLeaderboard.rewardExpireDays': 'Reward Expiry Days (-1 = never)',
  'activity.vendorLeaderboard.rewardExpireDaysTip': '-1 means never expires',
  'activity.vendorLeaderboard.grantAudit': 'Grant Review',
  'activity.vendorLeaderboard.grantAuditTip': 'On = pay after ops review; Off = auto-pay without review',
  'activity.vendorLeaderboard.on': 'On',
  'activity.vendorLeaderboard.off': 'Off',
  'activity.vendorLeaderboard.activityRule': 'Activity Rules (ops config, per board)',
  'activity.vendorLeaderboard.ruleTip': 'Ops fill in the activity rules line by line to match the front-end gameplay description. Items can be added/removed and are shown in order in the front-end rule popup. Fill one set per language (ZH / EN).',
  'activity.vendorLeaderboard.ruleItems': 'Rule Items',
  'activity.vendorLeaderboard.ruleItemPlaceholder': 'Enter a rule item',
  'activity.vendorLeaderboard.addRuleItem': 'Add Rule Item',
  'activity.vendorLeaderboard.errNoBoard': 'Configure at least one board',
  'activity.vendorLeaderboard.errBoardName': 'Board "{{name}}" requires both ZH and EN names',
  'activity.vendorLeaderboard.errVip': 'Board "{{name}}": please select VIP levels',
  'activity.vendorLeaderboard.errNoReward': 'Board "{{name}}": configure at least one reward tier',
  'activity.vendorLeaderboard.errRewardValue': 'Board "{{name}}": reward value must be greater than 0',
  'activity.vendorLeaderboard.errSpinTicket': 'Board "{{name}}": please select a spin type',
  'activity.vendorLeaderboard.errLastBoard': 'Keep at least one board',
  'activity.vendorLeaderboard.errRankOverlap': 'Board "{{name}}": ranks are duplicated or overlapping, please check',
  'activity.vendorLeaderboard.rankConflictHint': 'Ranks are duplicated or overlapping (highlighted). Each rank can only be configured once — please adjust before saving',
  'fsBatch.platformCode': 'Platform Code',
  'fsBatch.currency': 'Currency',
  'fsBatch.batchNo': 'Batch No.',
  'fsBatch.status': 'Status',
  'fsBatch.query': 'Search',
  'fsBatch.reset': 'Reset',
  'fsBatch.dispatchTime': 'Dispatch Time',
  'fsBatch.finishTime': 'Finish Time',
  'fsBatch.addDispatch': 'New Dispatch',
  'fsBatch.games': 'Games',
  'fsBatch.rounds': 'Rounds',
  'fsBatch.total': 'Total',
  'fsBatch.expanded': 'Generated',
  'fsBatch.progress': 'Progress',
  'fsBatch.action': 'Action',
  'fsBatch.detail': 'Details',
  'fsBatch.viewProgress': 'View Progress',
  'fsBatch.refreshProgress': 'Refresh',
  'fsBatch.progressText': 'Success {{success}} / Fail {{fail}} / Pending {{pending}}',
  'fsBatch.batchStatus.0': 'Created',
  'fsBatch.batchStatus.1': 'Generating',
  'fsBatch.batchStatus.2': 'Dispatching',
  'fsBatch.batchStatus.3': 'Done',
  'fsBatch.batchStatus.4': 'Partial Failed',
  'fsBatch.batchStatus.5': 'Failed',
  'fsBatch.submitTitle': 'New Free Spin Dispatch',
  'fsBatch.platformCodeRequired': 'Please enter platform code',
  'fsBatch.platformCodePlaceholder': 'e.g. SL_FC',
  'fsBatch.currencyRequired': 'Please select currency',
  'fsBatch.currencyPlaceholder': 'Please select currency',
  'fsBatch.gameIds': 'Game IDs',
  'fsBatch.gameIdsRequired': 'Please select games',
  'fsBatch.gameIdsPlaceholder': 'Select games (multiple)',
  'fsBatch.gameIdsEmpty': 'Select a platform first, or add games in the game list',
  'fsBatch.roundsLabel': 'Rounds',
  'fsBatch.roundsRequired': 'Please enter rounds',
  'fsBatch.roundsPlaceholder': 'Free spin rounds per member',
  'fsBatch.denomination': 'Denomination (optional)',
  'fsBatch.denominationPlaceholder': 'Leave blank for game default',
  'fsBatch.startTime': 'Start Time (optional)',
  'fsBatch.startTimePlaceholder': 'Blank = effective now',
  'fsBatch.endTime': 'End Time',
  'fsBatch.endTimeRequired': 'Please select end time',
  'fsBatch.endTimePast': 'End time cannot be earlier than now',
  'fsBatch.endBeforeStart': 'End time must be later than start time',
  'fsBatch.endTimePlaceholder': 'Validity deadline',
  'fsBatch.memberFile': 'Member List',
  'fsBatch.selectCsv': 'Select CSV File',
  'fsBatch.csvFormatHint': 'CSV format: header row, then one member account per line',
  'fsBatch.downloadTemplate': 'Download template',
  'fsBatch.remark': 'Remark (optional)',
  'fsBatch.remarkPlaceholder': 'Purpose of this dispatch',
  'fsBatch.uploadRequired': 'Please upload the member list CSV',
  'fsBatch.fileSizeLimit': 'File cannot exceed 30MB',
  'fsBatch.uploadFailed': 'File upload failed',
  'fsBatch.submitFailed': 'Submit failed',
  'fsBatch.submitSuccess': 'Dispatch submitted, batch No.: {{batchNo}}',
  'fsBatch.taskTitle': 'Dispatch Details',
  'fsBatch.memberId': 'Member Account',
  'fsBatch.vendorUsername': 'Vendor Account',
  'fsBatch.currency': 'Currency',
  'fsBatch.attempt': 'Retries',
  'fsBatch.vendorTxId': 'Vendor Tx ID',
  'fsBatch.errorCode': 'Error Code',
  'fsBatch.errorMsg': 'Error Message',
  'fsBatch.taskStatus.0': 'Pending',
  'fsBatch.taskStatus.1': 'Processing',
  'fsBatch.taskStatus.2': 'Success',
  'fsBatch.taskStatus.3': 'Failed',
  'fsBatch.whitelistTab': 'Free Spin Game List',
  'fsBatch.dispatchTab': 'Free Spin Dispatch',
  'fsBatch.wlId': 'ID',
  'fsBatch.wlGameId': 'Game ID',
  'fsBatch.wlGameName': 'Game Name',
  'fsBatch.wlUpdateTime': 'Update Time',
  'fsBatch.wlEnabled': 'Enabled',
  'fsBatch.wlDisabled': 'Disabled',
  'fsBatch.wlEnable': 'Enable',
  'fsBatch.wlDisable': 'Disable',
  'fsBatch.wlDelete': 'Delete',
  'fsBatch.wlAdd': 'Add',
  'fsBatch.wlAddTitle': 'Add Whitelist Game',
  'fsBatch.wlGameIdRequired': 'Please enter game ID',
  'fsBatch.wlGameIdPlaceholder': 'Vendor-side game_id',
  'fsBatch.wlGameNamePlaceholder': 'Please enter game name',
  'fsBatch.wlDeleteConfirm': 'Delete this game?',
  'fsBatch.wlDeleteSuccess': 'Deleted',
  'fsBatch.wlAddSuccess': 'Added',
  'fsBatch.wlOpSuccess': 'Operation succeeded',
  'fsBatch.wlOpFailed': 'Operation failed',
  'chickActivity.continuousCheckin': 'Consecutive Check-in',
  'chickActivity.continuousCheckinDesc': 'When disabled: the check-in entry is hidden on the frontend; accumulated streak days are kept and continue after re-enabling.',
  'chickActivity.continuousCheckinRule': 'Rules (fixed): counting starts on the first check-in day; missing one day resets to day 1; day N of the streak grants the day-N reward, and a full cycle loops back to day 1; max one check-in per day. Cash rewards require the turnover multiple before withdrawal (no separate switch).',
  'chickActivity.continuousTargetDay': 'Target Streak Days',
  'chickActivity.dayUnit': 'day(s)',
  'chickActivity.coupon': 'Ticket',
  'chickActivity.couponTemplate': 'Ticket Template',
  'chickActivity.selectCouponTemplate': 'Select ticket template',
  'chickActivity.depositCheckinV2': 'Deposit Check-in (Multi-dimension · Multi-reward)',
  'chickActivity.statMetric': 'Metric',
  'chickActivity.byAmount': 'By Amount',
  'chickActivity.byCount': 'By Count',
  'chickActivity.byAmountHint': 'By amount: tiers are matched by accumulated deposit amount.',
  'chickActivity.byCountHint': 'By count: tiers are matched by accumulated deposit count; reward base is still the accumulated deposit amount.',
  'chickActivity.cycleSpan': 'Cycle Length',
  'chickActivity.rewardTypesMulti': 'Reward types (multi-select, at least one)',
  'chickActivity.v2Formula': 'Cash/Points: total = accumulated deposit × tier "{span}-day total ratio" → split by D1–D{span} curve (sum=100%); Ticket: per tier "template + total qty" → split by qty curve (sum = total qty, integers).',
  'chickActivity.v2FormulaNote': 'Amounts truncated to 2 decimals; ratios support 1 decimal. Cap configurable on the highest tier only (no cap for tickets). Upgrading tier restarts the round from day 1 (no double check-in the same day); after completing a round, the next deposit starts a new round.',
  'chickActivity.tierRangeTitle': 'Tier Ranges (shared by cash/points/tickets)',
  'chickActivity.depositAmountRange': 'Deposit Amount Range',
  'chickActivity.depositCountRange': 'Deposit Count Range',
  'chickActivity.amountUnit': 'amount',
  'chickActivity.countUnit': 'count',
  'chickActivity.noUpperLimit': 'No limit (-1)',
  'chickActivity.depositAmount': 'deposit amount',
  'chickActivity.depositCount': 'deposit count',
  'chickActivity.tierRange': 'Tier',
  'chickActivity.thresholdMin': 'Threshold (amount; achieved when first deposit of the day >= threshold)',
  'chickActivity.baseCapCash': 'Cash calculation base cap (amount)',
  'chickActivity.baseCapPoints': 'Points calculation base cap (amount)',
  'chickActivity.baseCapHint': 'Reward base = min(first deposit of the day, cap); tier matching is not affected; empty = no cap. E.g. deposit 1,000,000 with cap 10,000 is calculated as 10,000.',
  'chickActivity.dailyRatioCurveTitle': ' - Daily ratio by streak day (%, applied to the first deposit of the day; each day independent, no 100% sum required)',
  'chickActivity.dailyRatioExample': 'Example: tier D3 ratio 10%, first deposit 150, that tier pays 150 x 10% = 15 that day (tiers stack when multiple are achieved).',
  'chickActivity.cycleSpanHintV3': 'Cycle = max streak length per tier: after exceeding it the tier loops back to D1; each tier counts independently, and missing a tier threshold (or not signing) resets only that tier.',
  'chickActivity.v3Formula': 'Only the first deposit of the day is used for tier matching, one sign-in per day (settles all tiers at once); every tier whose threshold is reached counts: its streak +1, cash/points pay ratio x min(first deposit, base cap) stacked across tiers, coupons pay by each tier\'s day curve.',
  'chickActivity.v3FormulaNote': 'Missing a tier threshold (or not signing that day) resets that tier\'s streak to D1; other achieved tiers are unaffected. Amounts truncated to 2 decimals; points truncated to integer.',
  'chickActivity.tierRangeTitleV3': 'Tier thresholds (shared by cash/points/tickets; lowest >=1, strictly increasing, stackable)',
  'chickActivity.wagerMultipleHint': 'Required turnover = tier reward x multiple (all games, no deadline); 0/empty = no requirement',
  'chickActivity.couponCurveTitleV3': 'Ticket curve (paid by each tier\'s streak day D; total is config-side validation only, restart re-pays from D1, no runtime cap)',
  'chickActivity.v3FootNote': 'Adding/removing tiers syncs all enabled reward type rows; currencies are independent; tier name is the streak state key - renaming after launch restarts that tier\'s streaks.',
  'chickActivity.totalRatioPercent': ' total ratio (%)',
  'chickActivity.highestTierCap': 'Highest Tier Cap',
  'chickActivity.onlyHighestTier': 'Highest tier only',
  'chickActivity.curveTotal': 'Total',
  'chickActivity.splitCurveTitle': ' split curve (sum=100%)',
  'chickActivity.couponCurveTitle': 'Ticket distribution curve (split by qty, integers, sum = total qty)',
  'chickActivity.couponTotalQty': 'Total Qty',
  'chickActivity.typeConfigSuffix': ' Config',
  'chickActivity.cashWagerEnable': 'Enable turnover requirement (must complete before withdrawal)',
  'chickActivity.wagerBase': 'Turnover base',
  'chickActivity.wagerBaseReward': 'Reward only',
  'chickActivity.wagerBaseRewardDeposit': 'Reward + deposit',
  'chickActivity.wagerScope': 'Turnover scope',
  'chickActivity.wagerScopeAll': 'All games',
  'chickActivity.wagerScopeSports': 'Sports only',
  'chickActivity.wagerScopeLive': 'Live only',
  'chickActivity.wagerScopeSlots': 'Slots only',
  'chickActivity.wagerDeadline': 'Turnover deadline (days)',
  'chickActivity.wagerMultipleTimes': 'Turnover multiple (x)',
  'chickActivity.wagerNote': 'Note',
  'chickActivity.wagerFormula': 'Required turnover = tier reward × multiple',
  'chickActivity.v2FootNote': 'Adding/removing tiers syncs curve rows of all enabled reward types; currencies are independent; switching metric/cycle/reward types does not clear entered values.',
  'chickActivity.applyScope': 'Game Brand Scope',
  'chickActivity.allBrands': 'All brands',
  'chickActivity.allGamesOfBrand': 'All games of brand',
  'chickActivity.specificGames': 'Specific games',
  'chickActivity.selectGamesPlaceholder': 'Search and select games',
  'chickActivity.scopeHint': 'With "Specific games", only bets on selected games count towards this milestone; brand and single games are mutually exclusive.',
  'chickActivity.scopeInherit': 'Inherit default',
  'chickActivity.scopeOverride': 'Override',
  'chickActivity.defaultScopeTitle': 'Scope (default; new tiers inherit it, overridable per tier)',
  'chickActivity.tierScopeTitle': 'Tier Game Brand Scope',
  'chickActivity.tierScopeHint': '"Inherit default" follows the module-level scope; overriding affects this tier only.',
  'chickActivity.currentDefault': 'Current default',
  'activity.chickActivity.report.continuousClaimCount': 'Consecutive Check-in Claimers',
  'activity.chickActivity.report.continuousCash': 'Consecutive Check-in Cash',
  'activity.chickActivity.report.continuousPoints': 'Consecutive Check-in Points',
  'activity.chickActivity.report.continuousCoupon': 'Consecutive Check-in Tickets',
  'activity.chickActivity.report.v2ClaimCount': 'Deposit Check-in Claimers',
  'activity.chickActivity.report.v2Cash': 'Deposit Check-in Cash',
  'activity.chickActivity.report.v2Points': 'Deposit Check-in Points',
  'activity.chickActivity.report.v2Coupon': 'Deposit Check-in Tickets',
  'chickActivity.allGamesLabel': 'All games',
  'chickActivity.andMoreItems': 'and {n} items',
  'chickActivity.scopeTreeHint': 'Three-level selection: Category → Platform → Game; nothing selected = all games',
  'chickActivity.pickGames': 'Pick games',
  'chickActivity.collapseGames': 'Collapse',
  'chickActivity.selectedGamesCount': '{n} selected',
  'chickActivity.noGames': 'No game data for this platform',
  'chickActivity.editCopy': 'Edit Copy',
  'chickActivity.taskNameLabel': 'Task Name',
  'chickActivity.taskDescLabel': 'Task Description',
  'chickActivity.pickGamesHint': 'Check specific games; none checked = all games of this platform',
  'chickActivity.searchGamePlaceholder': 'Search platform / game name',
};

